import React, { useState, useEffect,useRef } from "react";
import ReportsSection from "../components/ReportDropdown2";
import Profile from "../components/Profile";
import { updateProfile } from "firebase/auth";
import ProductService from "../components/ProductService";
import { useNavigate } from 'react-router-dom';
import PersonalInfoForm from "../components/PersonalInfoForm";
import { FiEye, FiEyeOff } from "react-icons/fi";

import OrganizationForm from "../components/OrganizationForm";
import IndustrySection from "../components/IndustrySection";
import MembershipSection from "../components/MembershipSection";
import SectionD from "../components/SectionD";
import SectionDnew from "../components/SectionDnew";
import BackgroundInfoSection from "../components/BackgroundInfoSection";
import LocationPicker from "./LocationPicker";
import { motion, AnimatePresence } from "framer-motion";
import GroupExperience from "../components/GroupExperience";
import Modal from "react-modal";
import SaveButtonWithModal from "../components/SaveButtonWithModel";
import { getFirestore, setDoc, doc, getDoc, increment, updateDoc, runTransaction, collection, addDoc } from "firebase/firestore";
import {
    getAuth,
    createUserWithEmailAndPassword,
    fetchSignInMethodsForEmail,
    sendPasswordResetEmail
} from "firebase/auth";
import { generateRegistrationNumber } from "../utils/generateRegNumber";
import { uploadToCloudinary } from "../utils/CloudinaryUpload";
import { sendRegistrationEmail } from "../utils/sendRegistrationsEmail";
import { initializeApp } from "firebase/app";
import { firebaseConfig } from "../firebase"; // Make sure `firebaseConfig` is exported from your firebase.js
import { signInWithEmailAndPassword } from "firebase/auth";
import PDFGenerator from "../components/PDFGenerator";
import PDFPreviewPage from "../components/PDFPreviewPage";
import { useCountry } from './CountryContext';

// Init Firebase singletons
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const dropdownItems = {
    FACILITATOR: [
        "**Input Supply (VIS)**",
        "Seeds, fertilizers, pesticides, machinery Financial services (credit, insurance) Extension services and training.", 
      
        "",
        
        "**Production (VPR)**",
        "Farming activities (planting, irrigating, tending crops/livestock) Harvesting",
        "",
        
        "**Post-Harvest Handling (VPH)**",
        " Cleaning, sorting, grading Primary storage Packaging", 
        "",
        
        "**Processing (VPR)**",
        "Milling, drying, canning, juicing, meat processing Adding preservatives, branding, or recipes", 
        "",
        
        "**Distribution and Marketing (VDM)**",
        "Transportation Wholesaling Retailing Market access platforms",
        "",
        
        "**Consumption (VCO)**",
        "Households Restaurants Institutions (schools, hospitals)",
        "",
        
        "**Support Services (VSS) (Cross-cutting)**",
        "(Cross-cutting) Research and development Infrastructure (roads, electricity, water) ICT and digital tools Policy and regulatory frameworks",
    ],

    PURPOSE: [
        "Funding", 
        "Training", 
        "Resourcing", 
        "Market", 
        "Internship", 
        "Research", 
        "Innovation", 
        "M&E", 
        "Assessment", 
        "Evaluations", 
        "Impact", 
        "EIA", 
        "Development", 
        "Regulation"
    ]
};
const language = {

    FACILITATOR: [
   // South Africa
  "Afrikaans" , 
  "English",
  "isiNdebele",
  "Sepedi",
  "Setswana",
  "Sesotho",
  "isiSwati",
  "Xitsonga",
  "isiZulu",
  
  // Namibia
  "Oshiwambo",
  "German",
  "Nama/Damara",
  "Herero",
  
  // Kenya
  "Swahili",
  
  // Botswana
  "Setswana",
  
  // Zimbabwe
  "Shona",
  "Ndebele",
  
  // Mozambique
  "Portuguese",
  "Emakhuwa",
  "Xichangana",
  
  // Default from dropdownItems.LANGUAGE
  "French",
  "Kiswahili"

    ],


};
const SMMEsOptions = [
  {
    "heading": "Smallholder Commercial Farms",
    "items": [
      {
        "label": "Small-scale farms operating for profit. Use improved inputs, some mechanization, and sell surplus to local markets. Often family-run but may hire seasonal labor. Example: A 5-hectare maize farm using hybrid seeds and selling to a local mill.",
        "value": "ESC"
      }
    ]
  },
  {
    "heading": "Medium-Scale Farms",
    "items": [
      {
        "label": "Larger landholding than smallholders (e.g., 10–100 hectares). Often mechanized and more capitalized. Supply supermarkets, processors, or export markets. Example: A 50-hectare rice farm with irrigation and a tractor, selling to a national rice brand.",
        "value": "EMS"
      }
    ]
  },
  {
    "heading": "Farmer Cooperatives / Producer Organizations",
    "items": [
      {
        "label": "Groups of farmers who pool resources to gain market power. May own equipment, storage, or transport collectively. Can register as SMEs and operate commercially. Example: A cooperative of 100 tomato farmers owning a cold storage unit.",
        "value": "EFC"
      }
    ]
  },
  {
    "heading": "Contract Farming SMEs",
    "items": [
      {
        "label": "Farmers or farm groups under formal agreements to supply crops/livestock to processors or exporters. Often receive inputs and training from buyers. Example: Poultry farmers supplying eggs to a food company under a contract.",
        "value": "ECF"
      }
    ]
  },
  {
    "heading": "Niche or Specialized Farms",
    "items": [
      {
        "label": "Farms focused on high-value or specialized production: Organic farms, Horticulture farms (vegetables, flowers, herbs), Aquaculture enterprises, Livestock or poultry SMEs, Beekeeping and honey production. Example: A small farm producing organic herbs for export.",
        "value": "ENS"
      }
    ]
  },
  {
    "heading": "Agri-Entrepreneurs with Integrated Operations",
    "items": [
      {
        "label": "These SMEs farm and also manage part of the value chain, such as: On-farm processing (e.g., dairy to yogurt), Direct-to-consumer sales (farm shops, online orders). Example: A mushroom farmer selling pre-packed mushrooms to urban grocers.",
        "value": "EAE"
      }
    ]
  },
  {
    "heading": "Youth or Women-led Farming Startups",
    "items": [
      {
        "label": "Often tech-savvy and innovative. Use climate-smart or digital farming tools. May focus on urban/peri-urban agriculture. Example: A woman-led hydroponic vegetable farm near a city.",
        "value": "EYW"
      }
    ]
  },
]
Modal.setAppElement("#root"); // Replace '#root' with the ID of your root element
const initialReportSelections = {
  COUNTRY: "-",
  REGION: "-",
  DISTRICT: "-",
  MUNICIPALITY: "-",
  SMMEs: "-",
  "VALUE CHAIN": "-",
  "TYPE OF FARMING": "-", // Add this line
  "USER TYPE": "-"
};
const Dropdown = ({ label, items, type, isProjectDropdown, isLanguageDropdown, onChange }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectedDocumentType, setSelectedDocumentType] = useState(null);
    
    // Scroll related states
    const contentRef = useRef(null);
    const [scrollTop, setScrollTop] = useState(0);
    const [thumbHeight, setThumbHeight] = useState(40);
    const [isDragging, setIsDragging] = useState(false);
    const [startY, setStartY] = useState(0);
    const [startScrollTop, setStartScrollTop] = useState(0);
    const thumbRef = useRef(null);
    const [currentHeading, setCurrentHeading] = useState(null);
    const handleDocumentTypeSelect = (type) => {
        setSelectedDocumentType(type);
        setSelectedItems([type]);
        setIsOpen(false);
        if (typeof onChange === "function") {
            onChange("PRODUCE", type);
        }
    };

    // Calculate thumb height based on content height
    useEffect(() => {
        const content = contentRef.current;
        if (!content) return;

        const updateThumbHeight = () => {
            const { scrollHeight, clientHeight } = content;
            const visibleRatio = clientHeight / scrollHeight;
            setThumbHeight(Math.max(visibleRatio * clientHeight, 20));
        };

        updateThumbHeight();
        window.addEventListener("resize", updateThumbHeight);
        return () => window.removeEventListener("resize", updateThumbHeight);
    }, [isOpen, items]);

    // Handle scroll events
    const handleScroll = () => {
        const content = contentRef.current;
        if (!content) return;

        const { scrollTop, scrollHeight, clientHeight } = content;
        const maxScrollTop = scrollHeight - clientHeight;
        const scrollRatio = scrollTop / maxScrollTop;
        const trackHeight = content.clientHeight - thumbHeight;
        setScrollTop(scrollRatio * trackHeight);
    };

    // Mouse down on thumb
    const handleThumbMouseDown = (e) => {
        e.preventDefault();
        e.stopPropagation();

        setIsDragging(true);
        setStartY(e.clientY);
        setStartScrollTop(contentRef.current.scrollTop);

        document.addEventListener("mousemove", handleThumbMouseMove);
        document.addEventListener("mouseup", handleThumbMouseUp);
        document.body.style.cursor = "grabbing";
    };

    // Mouse move when dragging thumb
    const handleThumbMouseMove = (e) => {
        if (!isDragging) return;

        const deltaY = e.clientY - startY;
        const content = contentRef.current;
        const { scrollHeight, clientHeight } = content;
        const maxScrollTop = scrollHeight - clientHeight;
        const trackHeight = clientHeight - thumbHeight;

        const scrollDelta = (deltaY / trackHeight) * maxScrollTop;
        const newScrollTop = Math.min(
            Math.max(0, startScrollTop + scrollDelta),
            maxScrollTop
        );

        content.scrollTop = newScrollTop;
    };

    // Mouse up when dragging thumb
    const handleThumbMouseUp = () => {
        setIsDragging(false);
        document.removeEventListener("mousemove", handleThumbMouseMove);
        document.removeEventListener("mouseup", handleThumbMouseUp);
        document.body.style.cursor = "";
    };

    // Click on track to jump to position
    const handleTrackClick = (e) => {
        const content = contentRef.current;
        if (!content || e.target === thumbRef.current) return;

        const track = e.currentTarget;
        const trackRect = track.getBoundingClientRect();
        const clickPosition = e.clientY - trackRect.top;
        const thumbCenter = thumbHeight / 2;
        const scrollRatio =
            (clickPosition - thumbCenter) / (trackRect.height - thumbHeight);

        const { scrollHeight, clientHeight } = content;
        const maxScrollTop = scrollHeight - clientHeight;
        content.scrollTop = scrollRatio * maxScrollTop;
    };

    // Button scroll handlers
    const handleButtonScroll = (direction) => {
        if (contentRef.current) {
            contentRef.current.scrollBy({
                top: direction === 'up' ? -50 : 50,
                behavior: 'smooth'
            });
        }
    };

    const findHeadingForItem = (item) => {
        let currentHeading = null;
        for (const element of items) {
            if (element.startsWith('**')) {
                currentHeading = element.replace(/\*\*/g, '');
            } else if (element === item) {
                return currentHeading;
            }
        }
        return null;
    };

    const handleSelect = (item) => {
        const heading = findHeadingForItem(item);
        if (heading) {
            setCurrentHeading(heading);
        }
        
        setSelectedItems(prev => {
            if (prev.includes(item)) {
                return prev.filter(i => i !== item);
            } else {
                return [...prev, item];
            }
        });
        
        if (typeof onChange === "function") {
            onChange(type, item);
        }
    };
    return (
        <div className="flex flex-col w-full relative">
            {/* Button showing selected items */}
            <span className="text-[6px] md:text-[20px] pl-2 mb-2 font-extrabold">
                {isLanguageDropdown
                    ? "LANGUAGE"
                    : isProjectDropdown
                    ? "PRODUCE"
                    : "VALUE CHAIN"}
            </span>
            <div className="flex relative z-50 w-fit">
                <button
                    onClick={() => {
                        if (isProjectDropdown && selectedItems.includes("Funding")) {
                            window.location.href = "/funding";
                        } else {
                            setIsOpen(prev => !prev);
                        }
                    }}
                    className={`xl:w-[250px] lg:w-[140px] md:w-[55px] w-[50px] h-[15px] md:h-[53px] bg-[#152C24] text-white font-medium flex items-center px-1 rounded-l-[5px]`}
                >
                     <span className="md:text-[18px] md:px-2 text-[4px] md:mt-0 mt-[2px] truncate">
                    {currentHeading || (selectedItems && selectedItems.length > 0 ? selectedItems[0] : "-")}
                </span>
                </button>

                <div
                    className="w-[15px] h-[15px] md:h-[53px] md:w-[37px] bg-[#EEB527] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer"
                    onClick={() => setIsOpen(prev => !prev)}
                >
                    <img
                        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745014174/Expand_down_3_ggzyur.png"
                        alt="expand"
                        className="w-2 h-[10px] md:w-6 md:h-[24px]"
                    />
                </div>
            </div>

            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -10 }}
                        className="absolute top-full mt-1 left-0 z-50"
                    >
                        {isProjectDropdown ? (
                            <div className="bg-white border border-gray-200 rounded-md shadow-lg py-2 min-w-[100px] md:min-w-[300px] max-h-[400px] flex">
                                <div className="flex-1 flex flex-col">
                                    <div className="px-3 md:px-2 pb-2 flex justify-between">
                                        <h1 className="text-[8px] md:text-[20px] font-bold text-black">
                                            Products / Services
                                        </h1>
                                        <img
                                            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747408675/Upload_duotone_line_vxnve7.png"
                                            alt=""
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setIsOpen(false);
                                            }}
                                            className="md:w-[43px] w-4 h-4 md:h-[42px]"
                                        />
                                    </div>

                                    <div className="w-full h-5 flex justify-end">
                                        <img
                                            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747461105/Expand_up_mflvtu.png"
                                            alt="scroll-up"
                                            className="md:w-4 md:h-4 h-2 w-2 cursor-pointer"
                                            onClick={() => {
                                                contentRef.current.scrollBy({
                                                    top: -50,
                                                    behavior: "smooth",
                                                });
                                            }}
                                        />
                                    </div>

                                    <div className="custom-scroll-area">
                                        <div
                                            className="custom-scroll-content"
                                            ref={contentRef}
                                            onScroll={handleScroll}
                                        >
                                            <h2 className="px-4 pt-3 pb-1 text-[8px] md:text-[20px] font-bold underline text-gray-700">
                                                CROPS
                                            </h2>
                                            {[
                                                "Avocados", "Apple", "Bananas and plantains", "Beans", "Beetroot", 
                                                "Capsicum", "Cabbage", "Cassava", "Cocoa", "Coffee", "Cotton", 
                                                "Citrus fruits", "Cowpeas", "Eggplant", "Groundnuts (peanuts)", 
                                                "Jute", "Kale", "Lentils", "Lemon", "Maize (corn)", "Millet", 
                                                "Mango", "Okra", "Onion", "Orange", "Palm oil", "Pineapples", 
                                                "Potatoes", "Pumpkin", "Rice", "Sorghum", "Soybeans", "Spinach", 
                                                "Strawberry", "Sugarcane", "Sunflower", "Sweet potatoes", "Tea", 
                                                "Tomatoes", "Water melon", "Vanilla", "Yam"
                                            ].map((type, index) => (
                                                <div
                                                    key={`crop-${index}`}
                                                    className="px-4 py-1 md:py-2 flex justify-between items-center hover:bg-gray-100 cursor-pointer text-[6px] md:text-[18px]"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleDocumentTypeSelect(type);
                                                    }}
                                                >
                                                    {type}
                                                    <div
                                                        className={`w-2 h-2 md:w-4 md:h-4 rounded-full ${
                                                            selectedDocumentType === type
                                                                ? "bg-[#152C24]"
                                                                : "bg-gray-200"
                                                        }`}
                                                    />
                                                </div>
                                            ))}

                                            <h2 className="px-4 pt-3 pb-1 text-[8px] md:text-[20px] font-bold underline text-gray-700">
                                                LIVESTOCK
                                            </h2>
                                            {[
                                                "Bees", "Cattle", "Camels", "Chicken", "Donkeys", "Ducks", 
                                                "Gunea Fowls", "Goats", "Pigs", "Rabbit", "Sheep", "Turkey"
                                            ].map((type, index) => (
                                                <div
                                                    key={`livestock-${index}`}
                                                    className="px-4 py-1 md:py-2 flex justify-between items-center hover:bg-gray-100 cursor-pointer text-[6px] md:text-[18px]"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleDocumentTypeSelect(type);
                                                    }}
                                                >
                                                    {type}
                                                    <div
                                                        className={`w-2 h-2 md:w-4 md:h-4 rounded-full ${
                                                            selectedDocumentType === type
                                                                ? "bg-[#152C24]"
                                                                : "bg-gray-200"
                                                        }`}
                                                    />
                                                </div>
                                            ))}

                                            <h2 className="px-4 pt-3 pb-1 text-[8px] md:text-[20px] font-bold underline text-gray-700">
                                                FISH
                                            </h2>
                                            {[
                                                "Catfish", "Common Carp", "Trout", "Tilapia"
                                            ].map((type, index) => (
                                                <div
                                                    key={`fish-${index}`}
                                                    className="px-4 py-1 md:py-2 flex justify-between items-center hover:bg-gray-100 cursor-pointer text-[6px] md:text-[18px]"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleDocumentTypeSelect(type);
                                                    }}
                                                >
                                                    {type}
                                                    <div
                                                        className={`w-2 h-2 md:w-4 md:h-4 rounded-full ${
                                                            selectedDocumentType === type
                                                                ? "bg-[#03897B]"
                                                                : "bg-gray-200"
                                                        }`}
                                                    />
                                                </div>
                                            ))}

                                            <h2 className="px-4 pt-3 pb-1 text-[8px] md:text-[20px] font-bold underline text-gray-700">
                                                FORESTRY
                                            </h2>
                                            {["Forest"].map((type, index) => (
                                                <div
                                                    key={`forest-${index}`}
                                                    className="px-4 py-1 md:py-2 flex justify-between items-center hover:bg-gray-100 cursor-pointer text-[6px] md:text-[18px]"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleDocumentTypeSelect(type);
                                                    }}
                                                >
                                                    {type}
                                                    <div
                                                        className={`w-2 h-2 md:w-4 md:h-4 rounded-full ${
                                                            selectedDocumentType === type
                                                                ? "bg-[#03897B]"
                                                                : "bg-gray-200"
                                                        }`}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                        <div
                                            className="custom-scroll-track"
                                            onClick={handleTrackClick}
                                        >
                                            <div
                                                ref={thumbRef}
                                                className="custom-scroll-thumb"
                                                style={{
                                                    height: `${thumbHeight}px`,
                                                    top: `${scrollTop}px`,
                                                    cursor: isDragging ? "grabbing" : "grab",
                                                }}
                                                onMouseDown={handleThumbMouseDown}
                                            ></div>
                                        </div>
                                    </div>

                                    <div className="w-full h-5 flex justify-end">
                                        <img
                                            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747461085/Expand_down_vbf4bb.png"
                                            alt="scroll-down"
                                            className="md:w-4 md:h-4 h-2 w-2 cursor-pointer"
                                            onClick={() => {
                                                contentRef.current.scrollBy({
                                                    top: 50,
                                                    behavior: "smooth",
                                                });
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="md:w-[280px] w-[70px] border-[1px] border-[#979797]/80 bg-white rounded-[1px] shadow-lg p-2">
                                <div className="w-full flex justify-end py-1">
                                    <button 
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleButtonScroll('up');
                                        }}
                                        className="p-1"
                                    >
                                        <img 
                                            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747461105/Expand_up_mflvtu.png" 
                                            alt="Scroll up" 
                                            className="w-3 h-3"
                                        />
                                    </button>
                                </div>

                                <div className="custom-scroll-area">
                                    <ul
                                        className="custom-scroll-content"
                                        ref={contentRef}
                                        onScroll={handleScroll}
                                    >
                                        <li className="flex items-center justify-between px-2 py-1">
                                            <span className="text-[6px] md:text-[16px] font-bold">
                                                {isProjectDropdown ? "Purpose" : "Value Chain"}
                                            </span>
                                            <img
                                                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745670022/Arhive_load_duotone_line_c6pcpp.png"
                                                alt="icon"
                                                className="md:w-[30px] md:h-[30px] h-[7px] w-[7px] cursor-pointer"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setIsOpen(false);
                                                }}
                                            />
                                        </li>
                                        {items.map((item, index) => (
                                            <li
                                                key={index}
                                                className={`flex items-start justify-between md:px-3 px-1 md:py-2 py-1 md:mt-1 rounded-md hover:bg-gray-100 cursor-pointer ${
                                                    selectedItems.includes(item) ? "bg-[#E7EBEB]" : ""
                                                } ${item.startsWith('**') ? 'font-bold pointer-events-none' : ''}`}
                                                onClick={() => !item.startsWith('**') && handleSelect(item)}
                                            >
                                                <div className="md:w-[190px]">
                                                    <span className="text-black text-[4px] md:text-[16px]">
                                                        {item.replace(/\*\*/g, '')}
                                                    </span>
                                                </div>
                                                {!item.startsWith('**') && (
                                                    <div
                                                        className={`w-2 h-2 md:w-5 md:h-5 rounded-full ${
                                                            selectedItems.includes(item) ? "bg-[#152C24]" : "bg-gray-200"
                                                        }`}
                                                    ></div>
                                                )}
                                            </li>
                                        ))}
                                    </ul>
                                    <div className="custom-scroll-track" onClick={handleTrackClick}>
                                        <div
                                            ref={thumbRef}
                                            className="custom-scroll-thumb"
                                            style={{
                                                height: `${thumbHeight}px`,
                                                top: `${scrollTop}px`,
                                                cursor: isDragging ? "grabbing" : "grab",
                                            }}
                                            onMouseDown={handleThumbMouseDown}
                                        ></div>
                                    </div>
                                </div>

                                <div className="w-full flex justify-end py-1">
                                    <button 
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleButtonScroll('down');
                                        }}
                                        className="p-1"
                                    >
                                        <img 
                                            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747461085/Expand_down_vbf4bb.png" 
                                            alt="Scroll down" 
                                            className="w-3 h-3"
                                        />
                                    </button>
                                </div>
                            </div>
                        )}
                    </motion.div>
                )}
            </AnimatePresence>
            <p className="md:text-[14px] text-[4px] font-normal mt-1 text-black">
                {isProjectDropdown
                    ? "Select type of Produce"
                    : `Select type of ${type === "FACILITATOR" ? "value chain" : label}`}
            </p>

            <style jsx>{`
                .custom-scroll-area {
                    position: relative;
                    max-height: 200px;
                    display: flex;
                    overflow: hidden;
                }

                .custom-scroll-content {
                    flex: 1;
                    overflow-y: scroll;
                    scrollbar-width: none;
                    -ms-overflow-style: none;
                    padding-right: 4px;
                }

                .custom-scroll-content::-webkit-scrollbar {
                    display: none;
                }

                .custom-scroll-track {
                    width: 14px;
                    background: #e7ebeb;
                    border-radius: 3px;
                    position: relative;
                    margin-left: 4px;
                    cursor: pointer;
                }

                .custom-scroll-thumb {
                    width: 100%;
                    background: #979797;
                    border-radius: 3px;
                    position: absolute;
                    right: 0;
                    transition: background 0.2s;
                }

                .custom-scroll-thumb:hover {
                    background: #444;
                }

                @media (max-width: 768px) {
                    .custom-scroll-track {
                        width: 4px;
                        margin-left: 2px;
                    }
                    .custom-scroll-area {
                        position: relative;
                        max-height: 150px;
                        display: flex;
                        overflow: hidden;
                        width: 100%;
                    }
                }
            `}</style>
        </div>
    );
}; 
const Dropdown1 = ({ label, items, type, isProjectDropdown, onChange }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectedCircles, setSelectedCircles] = useState({});
    
    // Scroll related states
    const contentRef = useRef(null);
    const [scrollTop, setScrollTop] = useState(0);
    const [thumbHeight, setThumbHeight] = useState(40);
    const [isDragging, setIsDragging] = useState(false);
    const [startY, setStartY] = useState(0);
    const [startScrollTop, setStartScrollTop] = useState(0);
    const thumbRef = useRef(null);

    const toggleCircle = (item) => {
        setSelectedCircles((prev) => ({
            ...prev,
            [item]: !prev[item],
        }));
    };

    const handleSelect = (item) => {
        setSelectedItems(prev => {
            if (prev.includes(item)) {
                return prev.filter(i => i !== item);
            } else {
                return [...prev, item];
            }
        });
        
        if (typeof onChange === "function") {
            onChange(type, item);
        }
    };

    // Calculate thumb height based on content height
    useEffect(() => {
        const content = contentRef.current;
        if (!content) return;

        const updateThumbHeight = () => {
            const { scrollHeight, clientHeight } = content;
            const visibleRatio = clientHeight / scrollHeight;
            setThumbHeight(Math.max(visibleRatio * clientHeight, 20));
        };

        updateThumbHeight();
        window.addEventListener("resize", updateThumbHeight);
        return () => window.removeEventListener("resize", updateThumbHeight);
    }, [isOpen, items]);

    // Handle scroll events
    const handleScroll = () => {
        const content = contentRef.current;
        if (!content) return;

        const { scrollTop, scrollHeight, clientHeight } = content;
        const maxScrollTop = scrollHeight - clientHeight;
        const scrollRatio = scrollTop / maxScrollTop;
        const trackHeight = content.clientHeight - thumbHeight;
        setScrollTop(scrollRatio * trackHeight);
    };

    // Mouse down on thumb
    const handleThumbMouseDown = (e) => {
        e.preventDefault();
        e.stopPropagation();

        setIsDragging(true);
        setStartY(e.clientY);
        setStartScrollTop(contentRef.current.scrollTop);

        document.addEventListener("mousemove", handleThumbMouseMove);
        document.addEventListener("mouseup", handleThumbMouseUp);
        document.body.style.cursor = "grabbing";
    };

    // Mouse move when dragging thumb
    const handleThumbMouseMove = (e) => {
        if (!isDragging) return;

        const deltaY = e.clientY - startY;
        const content = contentRef.current;
        const { scrollHeight, clientHeight } = content;
        const maxScrollTop = scrollHeight - clientHeight;
        const trackHeight = clientHeight - thumbHeight;

        const scrollDelta = (deltaY / trackHeight) * maxScrollTop;
        const newScrollTop = Math.min(
            Math.max(0, startScrollTop + scrollDelta),
            maxScrollTop
        );

        content.scrollTop = newScrollTop;
    };

    // Mouse up when dragging thumb
    const handleThumbMouseUp = () => {
        setIsDragging(false);
        document.removeEventListener("mousemove", handleThumbMouseMove);
        document.removeEventListener("mouseup", handleThumbMouseUp);
        document.body.style.cursor = "";
    };

    // Click on track to jump to position
    const handleTrackClick = (e) => {
        const content = contentRef.current;
        if (!content || e.target === thumbRef.current) return;

        const track = e.currentTarget;
        const trackRect = track.getBoundingClientRect();
        const clickPosition = e.clientY - trackRect.top;
        const thumbCenter = thumbHeight / 2;
        const scrollRatio =
            (clickPosition - thumbCenter) / (trackRect.height - thumbHeight);

        const { scrollHeight, clientHeight } = content;
        const maxScrollTop = scrollHeight - clientHeight;
        content.scrollTop = scrollRatio * maxScrollTop;
    };

    // Button scroll handlers
    const handleButtonScroll = (direction) => {
        if (contentRef.current) {
            contentRef.current.scrollBy({
                top: direction === 'up' ? -50 : 50,
                behavior: 'smooth'
            });
        }
    };

    return (
        <div className="flex flex-col w-full relative">
            {/* Button showing selected items */}
            <span className="text-[6px] md:text-[20px] md:pl-2 md:mb-3 font-extrabold">
        {isProjectDropdown ? "" : "Language"}
    </span>
            <div className="flex relative z-50 w-fit">
                <button
                    onClick={() => {
                        if (isProjectDropdown && selectedItems.includes("Funding")) {
                            window.location.href = "/funding";
                        } else {
                            setIsOpen(prev => !prev);
                        }
                    }}
                    className={`xl:w-[250px] lg:w-[140px] md:w-[55px] w-[50px] h-[15px] md:h-[53px] bg-[#152C24] text-white font-medium flex items-center px-1 rounded-l-[5px]`}
                >
                 <span className="md:text-[18px] md:px-2 text-[4px] md:mt-0 mt-[2px] truncate">
    {selectedItems.length > 0 ? selectedItems[0] : "-"}
</span>
                </button>

                <div
                    className="w-[15px] h-[15px] md:h-[53px] md:w-[37px] bg-[#EEB527] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer"
                    onClick={() => setIsOpen(prev => !prev)}
                >
                    <img
                        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745014174/Expand_down_3_ggzyur.png"
                        alt="expand"
                        className="w-2 h-[10px] md:w-6 md:h-[24px]"
                    />
                </div>
            </div>

            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -10 }}
                        className="absolute top-full mt-1 left-0 z-[100] md:w-[220px] w-[70px] border-[1px] border-[#979797]/80 bg-white rounded-[1px] shadow-lg p-2"
                    >
                        <div className="w-full flex justify-end py-1">
                            <button 
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleButtonScroll('up');
                                }}
                                className="p-1"
                            >
                                <img 
                                    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747461105/Expand_up_mflvtu.png" 
                                    alt="Scroll up" 
                                    className="w-3 h-3"
                                />
                            </button>
                        </div>

                        <div className="custom-scroll-area">
                            <ul
                                className="custom-scroll-content"
                                ref={contentRef}
                                onScroll={handleScroll}
                            >
                            <li className="flex items-center justify-between px-2 py-1 mb-2">
    <span className="text-[6px] md:text-[20px] font-semibold">
        {isProjectDropdown ? "Purpose" : "Langauge"}
    </span>
    <img
        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745670022/Arhive_load_duotone_line_c6pcpp.png"
        alt="icon"
        className="md:w-[30px] md:h-[30px] h-[7px] w-[7px] cursor-pointer"
        onClick={(e) => {
            e.stopPropagation(); // Prevent the li onClick from firing
            setIsOpen(false); // Close the dropdown
        }}
    />
</li>
                                
                                {items.map((item, index) => (
                                    <li
                                        key={index}
                                        className={`flex items-center justify-between md:px-3 px-1 md:py-2 py-1 md:mt-1 rounded-md hover:bg-gray-100 cursor-pointer ${
                                            selectedItems.includes(item) ? "bg-[#E7EBEB]" : ""
                                        }`}
                                        onClick={() => handleSelect(item)}
                                    >
                                        <span className="text-black text-[4px] md:text-[18px]">
                                            {item}
                                        </span>
                                        <div
                                            className={`w-2 h-2 md:w-8 md:h-8 rounded-full ${
                                                selectedItems.includes(item) ? "bg-[#152C24]" : "bg-gray-200"
                                            }`}
                                        ></div>
                                    </li>
                                ))}
                            </ul>
                            <div className="custom-scroll-track" onClick={handleTrackClick}>
                                <div
                                    ref={thumbRef}
                                    className="custom-scroll-thumb"
                                    style={{
                                        height: `${thumbHeight}px`,
                                        top: `${scrollTop}px`,
                                        cursor: isDragging ? "grabbing" : "grab",
                                    }}
                                    onMouseDown={handleThumbMouseDown}
                                ></div>
                            </div>
                        </div>

                        <div className="w-full flex justify-end py-1">
                            <button 
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleButtonScroll('down');
                                }}
                                className="p-1"
                            >
                                <img 
                                    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747461085/Expand_down_vbf4bb.png" 
                                    alt="Scroll down" 
                                    className="w-3 h-3"
                                />
                            </button>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
            <p className="md:text-[14px] text-[4px] font-normal mt-1 text-black">
                {isProjectDropdown
                    ? "Select type of Produce"
                    : `Select type of ${type === "FACILITATOR" ? "Language" : label}`}
            </p>

            <style jsx>{`
                .custom-scroll-area {
                    position: relative;
                    max-height: 200px;
                    display: flex;
                    overflow: hidden;
                }

                .custom-scroll-content {
                    flex: 1;
                    overflow-y: scroll;
                    scrollbar-width: none;
                    -ms-overflow-style: none;
                    padding-right: 4px;
                }

                .custom-scroll-content::-webkit-scrollbar {
                    display: none;
                }

                .custom-scroll-track {
                    width: 14px;
                    background: #e7ebeb;
                    border-radius: 3px;
                    position: relative;
                    margin-left: 4px;
                    cursor: pointer;
                }

                .custom-scroll-thumb {
                    width: 100%;
                    background: #979797;
                    border-radius: 3px;
                    position: absolute;
                    right: 0;
                    transition: background 0.2s;
                }

                .custom-scroll-thumb:hover {
                    background: #444;
                }

                @media (max-width: 768px) {
                    .custom-scroll-track {
                        width: 4px;
                        margin-left: 2px;
                    }
                    .custom-scroll-area {
                        position: relative;
                        max-height: 150px;
                        display: flex;
                        overflow: hidden;
                        width: 100%;
                    }
                }
            `}</style>
        </div>
    );
};
const languages = [
    "Owned",
    "Commonage",
    "Community Owned",
    "Municipal Land",
    "House with a plot",
    "Urban lot",
    "Community Food garden allocation",
    "No Land Yet",
];
const languages1 = [
    "Leased",
    "Community Leased",
    "Road side vacant land",
    "Village / Local/ Tribunal Authority allocation",
];

const RegisterAsFarm = () => {
    const [registrationData, setRegistrationData] = useState(null); // Define state for registration data
    const [membershipData, setMembershipData] = useState({
        selected: "",
        custom: ""
    }); // Initialize membershipData before usage
// Add this early in your component
const [showPassword, setShowPassword] = useState(false); // Define state for password visibility

const togglePasswordVisibility = () => {
  setShowPassword((prev) => !prev);
};
    const [selected, setSelected] = useState(null); // <-- initially nothing selected
    const [selected1, setSelected1] = useState(null); // <-- initially nothing selected
    const [selectedBox, setSelectedBox] = useState(null);
    const keys = Object.keys(dropdownItems);
    const navigate = useNavigate();

    const handleBoxClick = (index) => {
        setSelectedBox(index);
    };
    const setLandSizes = (newSizes) => {
        console.log("New sizes: ", newSizes);
    };
    const [isSaveModalOpen, setIsSaveModalOpen] = useState(false); // Save modal state
    const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false); // Registration modal state
    // Save Button Click Handler
    const handleSaveClick = () => {
        const dataToSave = {
            formData,
            orgFormData,
            dropdownSelections,
            reportSelections,
            selectedLanguage,
            landType1,
            landType2,
            erfNumber,
            selectedSkills,
            selectedMembership,
            selectedExperience,
            focusSelected,
            selectedType,
            selectedOption,
            selectedCategories,
            selectedChallenges,
            vision,
            selectedS,
            selectedQ,
            location,
        };
        localStorage.setItem("registrationData", JSON.stringify(dataToSave));
        setIsSaveModalOpen(true); // Open Save modal
    };
    const clearAllFormData = () => {
        // Clear all form states
        setFormData({
          firstName: "",
          surname: "",
          dateOfBirth: "",
          typeOfId: "",
          idNumber: "",
          mobile: "",
          email: "",
          password: "",
          whatsapp: "",
          physicalAddress: "",
          postalCode: "",
        });
        
        setOrgFormData({
          cooperativeName: "",
          registrationNumber: "",
          members: "",
          mobileNumber: "",
          physicalAddress: "",
          chairFirstName: "",
          chairSurname: "",
          secretaryFirstName: "",
          secretarySurname: "",
          email: "",
          password: "",
        });
        
        setDropdownSelections({
          user_type: dropdownItems.FACILITATOR[0],
          user_purpose: dropdownItems.PURPOSE[0],
        });
        
        setReportSelections(initialReportSelections);
        setSelectedLanguage(null);
        setLandType1("");
        setLandType2("");
        setErfNumber("");
        setSelectedSkills([]);
        setSelectedMembership("");
        setSelectedExperience([]);
        setFocusSelected([]);
        setSelectedType("");
        setSelectedOption("Maize");
        setSelectedCategories([]);
        setSelectedChallenges([]);
        setVision("");
        setSelectedS("Agri");
        setSelectedQ("Business Administration");
        setLocation(null);
        setProfileImage(null);
        setProductImages([]);
        setAgreed(false);
        
        // Clear from localStorage
        localStorage.removeItem("registrationData");
        
        // Close the modal
        setIsDeleteModalOpen(false);
        
        console.log("All registration data has been cleared");
      };
      
    const [isEditModalOpen, setIsEditModalOpen] = useState(false); // Edit modal state
    const [loginEmail, setLoginEmail] = useState(""); // Email input state
    const [loginPassword, setLoginPassword] = useState(""); // Password input state
    const [loginError, setLoginError] = useState(null); // Login error state
    // Handle Login from "Edit" Pop-up
    const handleLogin = async () => {
        try {
            setLoading(true);
            setLoginError(null); // Clear any previous errors

            // Attempt to sign in with email and password
            const userCredential = await signInWithEmailAndPassword(
                auth,
                loginEmail,
                loginPassword,
            );
            const userDoc = await getDoc(
                doc(db, "registrations", userCredential.user.uid),
            );

            if (userDoc.exists()) {
                const userData = userDoc.data();
                setFormData(userData.personalInfo || {}); // Populate form with user data
                setOrgFormData(userData.organizationInfo || {}); // Populate organization form data
                setDropdownSelections(userData.dropdownSelections || {});
                setReportSelections(userData.reportSelections || {});
                setSelectedLanguage(userData.language || null);
                setLandType1(userData.background?.landType1 || "");
                setLandType2(userData.background?.landType2 || "");
                setErfNumber(userData.background?.erfNumber || "");
                setSelectedSkills(userData.profingSkills || []);
                setSelectedMembership(userData.membership || "");
                setSelectedExperience(userData.groupExperience || []);
                setFocusSelected(userData.sectionD?.focusSelected || []);
                setSelectedType(userData.sectionD?.selectedType || "");
                setSelectedOption(userData.sectionD?.selectedOption || "Maize");
                setSelectedCategories(
                    userData.sectionD?.selectedCategories || [],
                );
                setSelectedChallenges(
                    userData.industry?.selectedChallenges || [],
                );
                setVision(userData.industry?.vision || "");
                setSelectedS(userData.setaQualification?.selectedS || "Agri");
                setSelectedQ(
                    userData.setaQualification?.selectedQ ||
                        "Business Administration",
                );
                setLocation(userData.location || null);

                setIsLoggedIn(true); // Mark user as logged in
                setIsEditModalOpen(false); // Close the modal upon successful login
                console.log("Login successful! User data loaded.");
            } else {
                console.error("No such document exists for the logged-in user.");
            }

            setLoading(false);
        } catch (error) {
            setLoading(false);

            // Provide feedback for login failure
            if (error.code === "auth/user-not-found") {
                setLoginError("No account found with this email.");
            } else if (error.code === "auth/wrong-password") {
                setLoginError("Incorrect password. Please try again.");
            } else {
                setLoginError(
                    "An error occurred during login. Please try again later.",
                );
            }

            console.error("Login failed:", error);
        }
    };
    // Close Save Modal
    const closeSaveModal = () => {
        setIsSaveModalOpen(false);
    };

    // Close Registration Modal
    const closeRegisterModal = () => {
        setIsRegisterModalOpen(false);
    };
    const [certificatesUrls, setCertificatesUrls] = useState([]);
    const [idDocumentUrl, setIdDocumentUrl] = useState("");
    const [dropdownSelections, setDropdownSelections] = useState({
        user_type: dropdownItems.FACILITATOR[0],
        user_purpose: dropdownItems.PURPOSE[0],
    });
    const [landType1, setLandType1] = useState("");
    const [landType2, setLandType2] = useState("");
    const [erfNumber, setErfNumber] = useState("");
    // ... other state
    const [selectedS, setSelectedS] = useState("Agri"); // initial SETA
    const [selectedQ, setSelectedQ] = useState("Business Administration"); // initial Qualification
    const [showDropdownError, setShowDropdownError] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false); // Track login status

    const handleDropdownSave = (data) => {
        // Log all values from the dropdowns in registration page
        console.log(" SETA and Qualification:", data);
        // data = { SETA: "Bank", QUALIFICATIONS: "IT Technical Support" }
    };
    const handleBackgroundSave = (data) => {
      console.log("Received land data:", data);
      setLandData(data); // Update local state
      
      // Update Firestore if user is logged in
      if (auth.currentUser) {
        const userRef = doc(db, "registrations", auth.currentUser.uid);
        updateDoc(userRef, {
          landData: data
        }).catch(error => {
          console.error("Error updating land data:", error);
        });
      }
    };
    
    const handleDropdownChange = (type, value) => {
        // Map dropdown type to your desired object keys
        const keyMap = {
            FACILITATOR: "user_type",
            PURPOSE: "user_purpose",
        };
        if (type === "FACILITATOR") {
            setDropdownSelections(prev => ({
                ...prev,
                user_type: value // This will be something like "Offtake Partner (OP)"
            }));
            console.log("User type selected:", value);
        }
    
        const mappedKey = keyMap[type];

        setDropdownSelections((prev) => ({
            ...prev,
            [mappedKey]: value,
        }));

        // Log only the mapped keys and latest values
        console.log({
            user_type:
                type === "FACILITATOR" ? value : dropdownSelections.user_type,
            user_purpose:
                type === "PURPOSE" ? value : dropdownSelections.user_purpose,
        });
    };
    const [selectedChallenges, setSelectedChallenges] = useState([]);
    const [vision, setVision] = useState("");

// In RegisterAsFarm.jsx - Update the handleIndustrySave function
// In RegisterAsFarm.jsx
const handleIndustrySave = (data) => {
  console.log("Industry Activity Survey:", data);
  setSelectedChallenges(data.selectedChallenges); // Store full challenge objects
  setVision(data.vision);
};
    const [challengeStats, setChallengeStats] = useState({
        'ACCESS TO FINANCE': 0,
        'COMPLIANCE': 0,
        'MARKET ACCESS': 0,
        'SKILL GAPS': 0,
        'TECHNOLOGY': 0,
        'CASH FLOW': 0,
        'MENTORSHIP': 0,
        'INSTABILITY': 0,
        'INNOVATION': 0,
        'INFORMATION ACCESS': 0,
        'SECURITY': 0,
        'OTHERS': 0
      });
      
    const [selectedExperience, setSelectedExperience] = useState([]);
    const [focusSelected, setFocusSelected] = useState([]);
    const [selectedType, setSelectedType] = useState("");
    const [showBackgroundError, setShowBackgroundError] = useState(false);
    // When the user clicks Register
    const getRegionName = (regionData) => {
      if (!regionData) {
        console.log("No region data provided");
        return null;
      }
      
      // If it's a string, check if it matches any region name
      if (typeof regionData === 'string') {
        const found = Object.keys(regionMap).find(key => 
          key.toLowerCase() === regionData.toLowerCase()
        );
        return found || null;
      }
      
      // If it's an object with value property
      if (regionData.value) {
        return Object.keys(regionMap).find(key => 
          regionMap[key] === regionData.value
        ) || null;
      }
      
      // If it's an object with name property
      if (regionData.name) {
        return Object.keys(regionMap).find(key => 
          key.toLowerCase() === regionData.name.toLowerCase()
        ) || null;
      }
      
      console.log("Could not resolve region from:", regionData);
      return null;
    };
    const regionMap = {
        "Gauteng": "01",
        "Eastern Cape": "02", 
        "Limpopo": "03",
        "KwaZulu-Natal": "04",
        "Mpumalanga": "05",
        "Western Cape": "06",
        "North West": "07",
        "Northern Cape": "08",
        "Free State": "09"
      };
     // Replace separate states with a single landData state
const [landData, setLandData] = useState({
  type1: { type: "", size: "", unit: "", hasLandSize: false },
  type2: { type: "", size: "", unit: "", hasLandSize: false },
  erfNumber: ''
});
      
      const [isPDFReady, setIsPDFReady] = useState(false);
const pdfGeneratorRef = useRef(null);
// Add this near the top of your RegisterAsFarm component
const generatePDF = async () => {
    try {
      if (pdfGeneratorRef.current) {
        await pdfGeneratorRef.current.generatePDF();
        return true;
      }
      return false;
    } catch (error) {
      console.error("Error generating PDF:", error);
      return false;
    }
  };
  console.log('Passing membership data to document page:', {
    selected: membershipData.selected,
    custom: membershipData.custom
  });
  const [customMembership, setCustomMembership] = useState("");
const [userLocation, setUserLocation] = useState(null);
// Add these near your other state declarations
const [isForgotPasswordModalOpen, setIsForgotPasswordModalOpen] = useState(false);
const [forgotPasswordEmail, setForgotPasswordEmail] = useState("");
const [verificationCode, setVerificationCode] = useState("");
const [newPassword, setNewPassword] = useState("");
const [confirmPassword, setConfirmPassword] = useState("");
const [forgotPasswordStep, setForgotPasswordStep] = useState(1); // 1 = email, 2 = code, 3 = new password
const [forgotPasswordError, setForgotPasswordError] = useState("");
const [forgotPasswordSuccess, setForgotPasswordSuccess] = useState("");
// Add these functions near your other handler functions
const handleForgotPassword = async () => {
  try {
    setForgotPasswordError("");
    if (!forgotPasswordEmail) {
      setForgotPasswordError("Please enter your email address");
      return;
    }

    // Always send the password reset email (don't check if email exists first)
    await sendPasswordResetEmail(auth, forgotPasswordEmail);
    setForgotPasswordStep(2); // Move to verification code step
    setForgotPasswordSuccess("A password reset link has been sent to your email");
  } catch (error) {
    console.error("Password reset error:", error);
    
    // Show success message even if email doesn't exist (for security)
    setForgotPasswordStep(2);
    setForgotPasswordSuccess("If an account exists, a password reset link has been sent");
    
    // Don't show the actual error to users
    setForgotPasswordError("");
  }
};

const handleVerifyCode = async () => {
  try {
    setForgotPasswordError("");
    if (!verificationCode) {
      setForgotPasswordError("Please enter the verification code");
      return;
    }

    // In a real implementation, you would verify the code here
    // For this example, we'll just move to the next step
    setForgotPasswordStep(3);
    setForgotPasswordSuccess("");
  } catch (error) {
    console.error("Verification error:", error);
    setForgotPasswordError("Invalid verification code");
  }
};

const handleResetPassword = async () => {
  try {
    setForgotPasswordError("");
    
    if (!newPassword || !confirmPassword) {
      setForgotPasswordError("Please enter and confirm your new password");
      return;
    }

    if (newPassword !== confirmPassword) {
      setForgotPasswordError("Passwords do not match");
      return;
    }

    if (newPassword.length < 6) {
      setForgotPasswordError("Password must be at least 6 characters");
      return;
    }

    // In a real implementation, you would update the password here
    // For this example, we'll just show a success message
    setForgotPasswordStep(1);
    setForgotPasswordSuccess("Password has been reset successfully!");
    setIsForgotPasswordModalOpen(false);
    
    // Clear form
    setForgotPasswordEmail("");
    setVerificationCode("");
    setNewPassword("");
    setConfirmPassword("");
  } catch (error) {
    console.error("Password reset error:", error);
    setForgotPasswordError(error.message);
  }
};
const challengesData = [
  {
    id: 1,
    title: "Limited Access to Finance",
    code: "ACCESS TO FINANCE",
    description: "Many farmers lack access to affordable credit and insurance.",
    solution: "Solution: Develop inclusive agricultural financing, microloans, and mobile banking services tailored to smallholders."
  },
  {
    id: 2,
    title: "Poor Infrastructure",
    code: "COMPLIANCE",
    description: "Inadequate roads, storage, and market facilities hinder distribution and increase post-harvest losses.",
    solution: "Solution: Invest in rural infrastructure, including roads, warehouses, and market access points."
  },
  {
    id: 3,
    title: "Low Access to Technology and Inputs",
    code: "MARKET ACCESS",
    description: "Limited availability of quality seeds, fertilizers, and modern tools.",
    solution: "Solution: Encourage public-private partnerships to improve input supply chains and subsidize access for small-scale farmers."
  },
  {
    id: 4,
    title: "Limited Agricultural Extension Services",
    code: "SKILL GAPS",
    description: "Farmers often lack access to updated farming knowledge and practices.",
    solution: "Solution: Strengthen extension services using mobile platforms, local training centers, and demonstration farms."
  },
  {
    id: 5,
    title: "Market Access and Price Volatility",
    code: "TECHNOLOGY",
    description: "Farmers struggle to connect with profitable markets and face unstable prices.",
    solution: "Solution: Support farmer cooperatives, develop value chains, and use digital platforms to connect farmers with buyers."
  },
  {
    id: 6,
    title: "Climate Change & Unpredictable Weather",
    code: "CASH FLOW",
    description: "Droughts, floods, and changing weather patterns disrupt farming cycles.",
    solution: "Solution: Promote climate-smart agriculture, drought-resistant seeds, and improved weather forecasting tools."
  },
  {
    id: 7,
    title: "Youth Disinterest in Agriculture",
    code: "MENTORSHIP",
    description: "Agriculture is seen as unprofitable and labor-intensive.",
    solution: "Solution: Promote agribusiness, use of technology, and access to land and finance for young entrepreneurs."
  },
  {
    id: 8,
    title: "Pests and Diseases",
    code: "INSTABILITY",
    description: "Crop and livestock pests can wipe out harvests and income.",
    solution: "Solution: Increase research on pest control, and provide early warning systems and access to effective pesticides or biological controls."
  },
  {
    id: 9,
    title: "Land Tenure Insecurity",
    code: "INNOVATION",
    description: "Many farmers work without formal land rights, discouraging long-term investment.",
    solution: "Solution: Implement land reforms and promote secure, documented land ownership."
  },
  {
    id: 10,
    title: "Lack of Skills and Technical Know-How",
    code: "INFORMATION ACCESS",
    description: "Limits smallholder farmers' productivity and income potential by preventing them from adopting modern, efficient farming practices.",
    solution: "Solution: Targeted training, access to extension services, and digital tools tailored to their needs."
  },
  {
    id: 11,
    title: "Crime and Insecurity",
    code: "SECURITY",
    description: "Disrupt smallholder farmers' activities by threatening their safety, crops, and livestock, leading to reduced productivity and investment.",
    solution: "Solution: Strengthened rural security, community policing, and support systems to protect livelihoods."
  },
  {
    id: 12,
    title: "Lack of Information",
    code: "INFORMATION ACCESS",
    description: "Prevents smallholder farmers from making informed decisions about markets, weather, and best practices, leading to lower yields and income.",
    solution: "Solution: Improved access to timely, relevant agricultural information through mobile platforms and extension services."
  },
  {
    id: 13,
    title: "Others",
    code: "OTHERS",
    description: "",
    solution: ""
  }
];
  // Update the handleRegister function to include PDF generation
  // Initialize idDocumentUrl at the top of your component with other state

// Update your handleRegister function
// In your RegisterAsFarm.jsx file, update the handleRegister function as follows:

const handleRegister = async () => {
  if (!validateForm()) {
    setRegistrationError("Please fill all required fields correctly");
    return;
  }

  setLoading(true);
  setRegistrationError(null);

  try {
    const selectedChallengeObjects = challengesData.filter(challenge => 
      selectedChallenges.includes(challenge.id)
    );

    // Check if email exists (new registrations only)
    if (!isLoggedIn) {
      const methods = await fetchSignInMethodsForEmail(auth, formData.email);
      if (methods.length > 0) throw new Error("auth/email-already-in-use");
    }

    // Generate registration number
    const regNumber = generateRegistrationNumber({
      COUNTRY: reportSelections.COUNTRY,
      REGION: reportSelections.REGION,
      DISTRICT: reportSelections.DISTRICT,
      MUNICIPALITY: reportSelections.MUNICIPALITY,
      SMMEs: reportSelections.SMMEs?.value || "",
      "USER TYPE": reportSelections["USER TYPE"]
    });

    // Update challenge stats if challenges are selected
    if (selectedChallenges.length > 0) {
      const statsRef = doc(db, "stats", "challenges");
      
      await runTransaction(db, async (transaction) => {
        const statsDoc = await transaction.get(statsRef);
        const currentData = statsDoc.exists() ? statsDoc.data() : {};
        
        // Get the country name (handle both string and object cases)
        const countryName = typeof reportSelections.COUNTRY === 'object' 
          ? reportSelections.COUNTRY.name 
          : reportSelections.COUNTRY;
        
        if (!countryName) {
          console.error("No country selected for challenge stats");
          return;
        }

        // Initialize country if not exists
        if (!currentData[countryName]) {
          currentData[countryName] = {};
        }

        // Update each selected challenge
        selectedChallenges.forEach(challengeId => {
          const challenge = challengesData.find(c => c.id === challengeId);
          if (challenge) {
            // Initialize challenge if not exists
            if (!currentData[countryName][challenge.code]) {
              currentData[countryName][challenge.code] = 0;
            }
            // Increment challenge count
            currentData[countryName][challenge.code] += 1;
          }
        });

        // Update the document with merged data
        transaction.set(statsRef, currentData);
      });
    }

    let uid;
    if (isLoggedIn) {
      uid = auth.currentUser.uid;
    } else {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        formData.email,
        formData.password
      );
      uid = userCredential.user.uid;
    
      await updateProfile(userCredential.user, {
        displayName: `${formData.firstName} ${formData.surname}`
      });
    }

    // Upload files if they exist
    let profileImageUrl = '';
    let productImageUrls = [];
    let certificateUrls = [];
    let idDocumentUrlFinal = idDocumentUrl || "";

    try {
      // Upload profile image if it exists
      if (profileImage && profileImage.file) {
        const profileUpload = await uploadToCloudinary(profileImage.file);
        profileImageUrl = profileUpload.url;
      } else if (profileImage?.url) {
        profileImageUrl = profileImage.url;
      }

      // Upload product images if they exist
      if (productImages.length > 0) {
        const uploadPromises = productImages.map(async (img) => {
          if (img.file) {
            const uploaded = await uploadToCloudinary(img.file);
            return uploaded.url;
          }
          return img.url || img.previewUrl || '';
        });
        productImageUrls = await Promise.all(uploadPromises);
      }

      // Upload certificates if they exist
      if (certificatesUrls.length > 0) {
        const uploadPromises = certificatesUrls.map(async (cert) => {
          if (cert.file) {
            const uploaded = await uploadToCloudinary(cert.file);
            return uploaded.url;
          }
          return cert.url || cert.previewUrl || '';
        });
        certificateUrls = await Promise.all(uploadPromises);
      }

      // Upload ID document if it exists
      if (idDocumentUrl && idDocumentUrl.file) {
        const idUpload = await uploadToCloudinary(idDocumentUrl.file);
        idDocumentUrlFinal = idUpload.url;
      }
    } catch (uploadError) {
      console.error("File upload error:", uploadError);
      throw new Error(uploadError.message || "Failed to upload files. Please try again.");
    }
// When registering, also save individual challenge submissions
const saveChallengeSubmission = async (uid, challenges, country) => {
  try {
    // Create a reference to the user's challenge submissions subcollection
    const submissionsRef = collection(db, "registrations", uid, "challengeSubmissions");
    
    // Add a new document for this submission
    await addDoc(submissionsRef, {
      challenges,
      country: typeof country === 'object' ? country.name : country,
      timestamp: new Date().toISOString()
    });
    
    // Also update the aggregated stats
    const statsRef = doc(db, "stats", "challenges");
    
    await runTransaction(db, async (transaction) => {
      const statsDoc = await transaction.get(statsRef);
      const currentData = statsDoc.exists() ? statsDoc.data() : {};
      
      // Get the country name
      const countryName = typeof country === 'object' ? country.name : country;
      
      if (!countryName) {
        console.error("No country selected for challenge stats");
        return;
      }

      // Initialize country if not exists
      if (!currentData[countryName]) {
        currentData[countryName] = {};
      }

      // Update each selected challenge
      challenges.forEach(challengeId => {
        const challenge = challengesData.find(c => c.id === challengeId);
        if (challenge) {
          // Initialize challenge if not exists
          if (!currentData[countryName][challenge.code]) {
            currentData[countryName][challenge.code] = 0;
          }
          // Increment challenge count
          currentData[countryName][challenge.code] += 1;
        }
      });

      // Update the document with merged data
      transaction.set(statsRef, currentData);
    });
  } catch (error) {
    console.error("Error saving challenge submission:", error);
  }
};

// Call this in your handleRegister function after successful registration
await saveChallengeSubmission(uid, selectedChallenges, reportSelections.COUNTRY);
    // Prepare data payload
    const userData = {
      uid,
      registrationNumber: regNumber,
      registrationDate: new Date().toISOString(),
      personalInfo: { 
        ...formData,
        race: race || "",
        gender: gender || "", 
        disability: disability || "",
        profileImage: profileImageUrl || ""
      },
      organizationInfo: {
        ...orgFormData,
        orgType: orgType || "",
        certificates: certificateUrls || [],
        idDocument: idDocumentUrlFinal || "",
        productImages: productImageUrls || []
      },
      dropdownSelections: dropdownSelections || {},
      reportSelections: {
        COUNTRY: typeof reportSelections.COUNTRY === 'object' 
          ? reportSelections.COUNTRY 
          : { name: reportSelections.COUNTRY },
        REGION: typeof reportSelections.REGION === 'object' 
          ? reportSelections.REGION 
          : { name: reportSelections.REGION },
        DISTRICT: typeof reportSelections.DISTRICT === 'object' 
          ? reportSelections.DISTRICT 
          : { name: reportSelections.DISTRICT },
        MUNICIPALITY: reportSelections.MUNICIPALITY,
        SMMEs: reportSelections.SMMEs,
        "VALUE CHAIN": reportSelections["VALUE CHAIN"],
        "TYPE OF FARMING": reportSelections["TYPE OF FARMING"],
        "USER TYPE": reportSelections["USER TYPE"]
      },
      language: selectedLanguage || "",
      landData: {
        type1: landData.type1 || { type: "", size: "", unit: "", hasLandSize: false },
        type2: landData.type2 || { type: "", size: "", unit: "", hasLandSize: false },
        erfNumber: landData.erfNumber || ""
      },
      profingSkills: selectedSkills || [],
      membership: membershipData.selected || "",
      customMembership: membershipData.custom || "",
      groupExperience: selectedExperience || [],
      sectionD: { 
        focusSelected: focusSelected || [], 
        selectedType: selectedType || "", 
        selectedOption: selectedOption || "Maize", 
        selectedCategories: selectedCategories || [] 
      },
      industry: { 
        selectedChallenges: selectedChallengeObjects,
        vision: vision 
      },
      setaQualification: { 
        selectedS: selectedS || "Agri", 
        selectedQ: selectedQ || "Business Administration" 
      },
      location: location || null,
      status: "active",
      lastUpdated: new Date().toISOString()
    };

    // Save to Firestore
// In handleRegister function:
const docRef = doc(db, "registrations", uid); // This already uses unique uid
// In handleRegister function:
await setDoc(doc(db, "registrations", uid), userData, { merge: false }); // merge: false ensures new doc
    // Update registration stats
    const countryName = typeof reportSelections.COUNTRY === 'object' 
      ? reportSelections.COUNTRY.name 
      : reportSelections.COUNTRY;
    
    const regionName = getRegionName(reportSelections.REGION);
    const smmeType = typeof reportSelections.SMMEs === 'object' 
      ? reportSelections.SMMEs.value 
      : reportSelections.SMMEs;

    if (countryName && regionName && smmeType) {
      const statsRef = doc(db, "stats", "registrations");
      
      // Calculate land size totals
      const landSize1 = landData.type1?.size ? parseFloat(landData.type1.size) : 0;
      const landSize2 = landData.type2?.size ? parseFloat(landData.type2.size) : 0;
      const totalLandSize = landSize1 + landSize2;
      const hasLandSize = totalLandSize > 0;

// Update the stats transaction to properly increment counts:
await runTransaction(db, async (transaction) => {
  const statsRef = doc(db, "stats", "registrations");
  const statsDoc = await transaction.get(statsRef);
  
  let statsData = statsDoc.exists() ? statsDoc.data() : {};
  
  // Initialize country if not exists
  if (!statsData[countryName]) {
    statsData[countryName] = {};
  }
  
  // Initialize region if not exists
  if (!statsData[countryName][regionName]) {
    statsData[countryName][regionName] = {
      total: 0,
      landSizeTotal: 0,
      bySmmetype: {}
    };
  }
  
  // Initialize SMME type if not exists
  if (!statsData[countryName][regionName].bySmmetype[smmeType]) {
    statsData[countryName][regionName].bySmmetype[smmeType] = {
      count: 0,
      landSizeTotal: 0
    };
  }
  
  // Increment counts
  statsData[countryName][regionName].total += 1;
  statsData[countryName][regionName].landSizeTotal += totalLandSize;
  statsData[countryName][regionName].bySmmetype[smmeType].count += 1;
  statsData[countryName][regionName].bySmmetype[smmeType].landSizeTotal += totalLandSize;
  
  transaction.set(statsRef, statsData);
});
    }

    setRegistrationNumber(regNumber);
    setIsModalOpen(true);
    
    // Send email
    if (formData.email) {
      await sendRegistrationEmail({
        user_name: `${formData.firstName} ${formData.surname}`,
        registration_number: regNumber,
        user_email: formData.email,
        user_type: dropdownSelections.user_type,
        name: `${formData.firstName} ${formData.surname}`,
        email: formData.email,
      });
    }
  } catch (error) {
    console.error("Registration error:", {
      name: error.name,
      message: error.message,
      stack: error.stack,
      code: error.code
    });
    
    let errorMessage = "Registration failed. Please try again.";
    
    if (error.code === 'auth/email-already-in-use') {
      errorMessage = "Email already in use.";
    } else if (error.code === 'auth/weak-password') {
      errorMessage = "Password should be at least 6 characters.";
    } else if (error.message.includes('upload files')) {
      errorMessage = error.message;
    }
    
    setRegistrationError(errorMessage);
  } finally {
    setLoading(false);
  }
};
 
      // Add this temporary test function somewhere in your component
      const testFirestoreConnection = async () => {
        try {
          const testDocRef = doc(db, "test_collection", "test_doc_" + Date.now());
          await setDoc(testDocRef, {
            test: true,
            timestamp: new Date().toISOString()
          });
          return true;
        } catch (error) {
          console.error("Detailed Firestore connection error:", error);
          return false;
        }
      };
  // Check if Firebase is initialized
console.log("Firebase app:", app?.name); 
console.log("Firestore instance:", db);
console.log("Auth instance:", auth);

// Check authentication state
auth.onAuthStateChanged((user) => {
  console.log("Auth state changed:", user ? "Logged in" : "Logged out");
});
  // Call it somewhere, like in a useEffect or button click
    const handleFocusSave = (data) => {
        console.log("Areas of Focus:", data);
        // {
        //   cooperativeName: ...,
        //   typeOfFocus: ...,
        //   selectedAreas: [...],
        //   selectedDisabilityType: ...
        // }
    };
    // Save User Data to Firestore
    const saveUserData = async (uid, regNumber) => {
        try {
          console.log("Attempting to save user data to Firestore...");
          
          if (!uid) throw new Error("No user ID provided");
          if (!regNumber) throw new Error("No registration number provided");
          
          // Prepare the user payload
          const userPayload = {
            uid,
            registrationNumber: regNumber,
            personalInfo: { 
              ...formData, 
              race: race || "", 
              gender: gender || "", 
              disability: disability || "",
              profileImage: profileImage?.url || profileImage?.previewUrl || ""
            },
            organizationInfo: { 
              ...orgFormData, 
              orgType: orgType || "",
              certificates: certificatesUrls || [],
              idDocument: idDocumentUrl || "",
              productImages: productImages.map(img => img.url || img.previewUrl).filter(Boolean) || []
            },
            dropdownSelections: dropdownSelections || {},
            reportSelections: {
              COUNTRY: reportSelections.COUNTRY?.name || reportSelections.COUNTRY || "--",
              REGION: reportSelections.REGION?.name || reportSelections.REGION || "--",
              DISTRICT: reportSelections.DISTRICT?.name || reportSelections.DISTRICT || "--",
              MUNICIPALITY: reportSelections.MUNICIPALITY || "--",
              SMMEs: reportSelections.SMMEs?.value || reportSelections.SMMEs || "--",
              "VALUE CHAIN": reportSelections["VALUE CHAIN"] || "--",
              "TYPE OF FARMING": reportSelections["TYPE OF FARMING"]|| "--",
              "USER TYPE": reportSelections["USER TYPE"] || "--"
            },
            language: selectedLanguage || "",
            landData: {
              type1: landType1 || "",
              type2: landType2 || "",
              erfNumber: erfNumber || ""
            },
            profingSkills: selectedSkills || [],
            membership: membershipData.selected || "",
            customMembership: membershipData.custom || "",
            groupExperience: selectedExperience || [],
            sectionD: { 
              focusSelected: focusSelected || [], 
              selectedType: selectedType || "", 
              selectedOption: selectedOption || "", 
              selectedCategories: selectedCategories || [] 
            },
            industry: { 
              selectedChallenges: selectedChallenges || [], 
              vision: vision || "" 
            },
            setaQualification: { 
              selectedS: selectedS || "", 
              selectedQ: selectedQ || "" 
            },
            location: location || null,
            registrationDate: new Date().toISOString(),
            status: "active",
            lastUpdated: new Date().toISOString()
          };
      
          console.log("User payload to save:", userPayload);
      
          // Save to Firestore with timeout
          const docRef = doc(db, "registrations", uid);
          await setDoc(docRef, userPayload);
          
          console.log("User data saved successfully to Firestore");
          return true;
        } catch (error) {
          console.error("Detailed Firestore save error:", {
            errorCode: error.code,
            errorMessage: error.message,
            errorStack: error.stack
          });
          
          if (error.code === 'permission-denied') {
            setRegistrationError("Database permission denied. Please contact support.");
          } else if (error.code === 'unavailable') {
            setRegistrationError("Network error. Please check your internet connection.");
          } else {
            setRegistrationError("Failed to save data: " + (error.message || "Unknown error"));
          }
          
          return false;
        }
      };
      const [isExpanded, setIsExpanded] = useState(false);

const toggleExpand = () => {
  setIsExpanded(!isExpanded);
};
    // Update Existing User Data
    const updateUserDetails = async () => {
        const user = auth.currentUser; // Get the currently logged-in user
        if (user) {
            const userDocRef = doc(db, "registrations", user.uid); // Reference to the user's document in Firestore
            const updatedPayload = {
                personalInfo: { ...formData },
                organizationInfo: { ...orgFormData },
                dropdownSelections,
                reportSelections,
                language: selectedLanguage,
                landData: { 
    landType1, landType2,
  erfNumber 
},
                background: { landType1, landType2, erfNumber },
                profingSkills: selectedSkills,
                membership: selectedMembership,
                groupExperience: selectedExperience,
                sectionD: {
                    focusSelected,
                    selectedType,
                    selectedOption,
                    selectedCategories,
                },
                industry: { selectedChallenges, vision },
                setaQualification: { selectedS, selectedQ },
                location,
                updatedAt: new Date().toISOString(), // Add a timestamp for updates
            };

            // Save updated data to Firestore
            await setDoc(userDocRef, updatedPayload, { merge: true }); // Merge updated data with existing document
            console.log("User details updated successfully.");
        } else {
            console.error("No logged-in user found.");
            throw new Error("User not logged in.");
        }
    };
  
    const [selectedOption, setSelectedOption] = useState("Maize");
    const [selectedCategories, setSelectedCategories] = useState([]);

    const handleSectionDSave = (data) => {
        // data = { typeOfOrganization: ..., categories: [...] }
        console.log("Section D Industry Interest:", data);
    };

    const handleGroupExperienceSave = (data) => {
        console.log("Group Experience:", data);
        // Example:
        // {
        //   cooperativeName: 'YourCooperativeName',
        //   typeOfGroupExperience: 'Personal, Group or Cooperative Experience',
        //   selectedExperience: [...]
        // }
    };

    // ProfingSkils state

const [showProfileSections, setShowProfileSections] = useState(false);

    const [profileImage, setProfileImage] = useState(null);
    const [productImages, setProductImages] = useState([]);
    const [agreed, setAgreed] = useState(false);
    const [showAgreementError, setShowAgreementError] = useState(false); // State for showing error
    const [selectedSkills, setSelectedSkills] = useState([]);
    const [selectedMembership, setSelectedMembership] = useState(""); // e.g. "AFASA" or "Others"
    // In RegisterAsFarm:
    
      
      const handleMembershipSave = (data) => {
        console.log("Membership data received:", data);
        if (data.type === 'selected') {
          setMembershipData(prev => ({
            ...prev,
            selected: data.value,
          }));
        } else {
          setMembershipData(prev => ({
            ...prev,
            custom: data.value,
          }));
        }
      };
      
    const handleProfingSkillsSave = (skills) => {
        // Example: log with cooperative name and type if you have them
        const data = {
            PersonalSkillsTrainingandQualifications:
                "PersonalSkillsTrainingandQualifications", // replace/fetch as needed
            typeOfProfingSkill: "Personal Skills Training and Qualifications",
            selectedSkills: skills,
        };
        console.log("Profing Skills:", data);
    };
    const [selectedLocation, setSelectedLocation] = useState(null);

    // Add your main save handler (use the same function as your Register button)
    const [savedLocation, setSavedLocation] = useState(null);
    const [isAdminModalOpen, setIsAdminModalOpen] = useState(false);
const [adminEmail, setAdminEmail] = useState("");
const [adminPassword, setAdminPassword] = useState("");
const [adminError, setAdminError] = useState("");
const handleAdminLogin = async () => {
  // Define valid admin credentials (email and password pairs)
  const validAdmins = [
    { email: "oyierallan@yahoo.com", password: "123@*Agulu" },
    { email: "allan.oyier@farmnet.africa", password: "123@*Agulu" },
    { email: "farmnetafr@gmai.com", password: "123@*Agulu" },
    { email: "oyiergweth@gmail.com", password: "123@*Agulu" }
  ];

  // Trim inputs to remove accidental whitespace
  const enteredEmail = adminEmail.trim();
  const enteredPassword = adminPassword.trim();

  // Find if any admin matches both email AND password
  const isValidAdmin = validAdmins.some(
    admin => 
      admin.email === enteredEmail && 
      admin.password === enteredPassword
  );

  if (isValidAdmin) {
    // Successful login - clear any previous errors and navigate
    setAdminError("");
    navigate("/Adminportal");
  } else {
    // Failed login - show appropriate error message
    const emailExists = validAdmins.some(admin => admin.email === enteredEmail);
    
    if (!enteredEmail || !enteredPassword) {
      setAdminError("Please enter both email and password");
    } else if (!emailExists) {
      setAdminError("Invalid admin credentials");
    } else {
      setAdminError("Incorrect password");
    }
  }
};
const SMMEsOptions = [
  {
    heading: "Agriculture and Agribusiness",
    items: [
      { label: "Smallholder farms", value: "SMF" },
      { label: "Agro-processing", value: "AGP" },
      { label: "Agri-input suppliers", value: "AIP" },
      { label: "Horticulture businesses", value: "HCB" },
      { label: "Poultry", value: "POF" },
      { label: "Fish farms", value: "FIF" },
      { label: "Agri-tech startups", value: "ATC" }
    ]
  },
  {
    heading: "Manufacturing and Processing",
    items: [
      { label: "Textile and garment production", value: "TGP" },
      { label: "Furniture making and carpentry", value: "FPC" },
      { label: "Metal fabrication", value: "MEF" },
      { label: "Soap and detergent production", value: "SDP" },
      { label: "Food and beverage processing", value: "FBP" }
    ]
  },
  {
    heading: "Retail and Trade",
    items: [
      { label: "Small shops (dukas/spazas)", value: "SDS" },
      { label: "Market vendors", value: "MAV" },
      { label: "Wholesalers and distributors", value: "WHD" },
      { label: "Online retail platforms", value: "ORP" }
    ]
  },
  {
    heading: "Services",
    items: [
      { label: "Transport and logistics", value: "TRL" },
      { label: "Repair services", value: "RPS" },
      { label: "Beauty and personal care", value: "BPC" },
      { label: "Laundry and dry cleaning", value: "LDC" },
      { label: "Hospitality", value: "HOS" },
      { label: "Event planning and catering", value: "EPC" }
    ]
  },
  {
    heading: "Technology and Innovation (Tech SMEs)",
    items: [
      { label: "Fintech", value: "FIT" },
      { label: "Healthtech", value: "HET" },
      { label: "Edtech", value: "EDT" },
      { label: "Software and app development", value: "SAD" },
      { label: "E-commerce and logistics tech", value: "ECL" }
    ]
  },
  {
    heading: "Construction and Real Estate",
    items: [
      { label: "Small construction firms", value: "SCF" },
      { label: "Real estate agents and developers", value: "RAD" },
      { label: "Hardware and building material suppliers", value: "HBM" }
    ]
  },
  {
    heading: "Creative and Cultural Industries",
    items: [
      { label: "Art and crafts production", value: "ACP" },
      { label: "Music and film production", value: "MFP" },
      { label: "Fashion and design businesses", value: "FDB" },
      { label: "Photography and videography services", value: "PVS" }
    ]
  },
  {
    heading: "Health and Wellness",
    items: [
      { label: "Private clinics and pharmacies", value: "PCP" },
      { label: "Fitness centers and gyms", value: "FCG" },
      { label: "Traditional medicine practitioners", value: "TMP" },
      { label: "Health product distributors", value: "HPD" }
    ]
  },
  {
    heading: "Education and Training",
    items: [
      { label: "Private schools and daycares", value: "PSD" },
      { label: "Vocational training centers", value: "VTC" },
      { label: "Tutoring services", value: "TUS" },
      { label: "Edtech startups", value: "EDS" }
    ]
  }
]

    // Call this when Register button is clicked
    const handleRegisterSave = () => {
        const cooperative = {
            // ...other registration fields,
            location: savedLocation,
        };
        console.log("location:", cooperative);
        // ...show modal, etc.
    };

    const [location, setLocation] = useState(null);

    // This gets called when "Save Location" is clicked inside LocationPicker
    const [locationCountry, setLocationCountry] = useState("");

    const handleSaveLocation = (country) => {
        setLocationCountry(country);
        console.log("User selected country:", country);
    };

    const [showUnits, setShowUnits] = useState(false);
    const [selectedUnit, setSelectedUnit] = useState("HA");
    const [landSize, setLandSize] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [copyMessage, setCopyMessage] = useState("");

    const [selected3, setSelected3] = useState("Individual");

    const handleCopy = () => {
        navigator.clipboard.writeText("ZA25-582-9511");
        setCopyMessage("Copied!"); // Set the "Copied!" message

        // Hide the message after 2 seconds
        setTimeout(() => {
            setCopyMessage("");
        }, 2000);
    };
    const closeModal = () => {
        setIsModalOpen(false);
    };
    const units = ["", "Acre", "Square Meter"];

    const handleUnitSelect = (unit) => {
        setSelectedUnit(unit);
        setShowUnits(false);
    };
    const { selectedCountry } = useCountry();
    // Report dropdown state
    const [reportSelections, setReportSelections] = useState({
      COUNTRY: selectedCountry || "-",
      REGION: "-",
      DISTRICT: "-",
      MUNICIPALITY: "-",
      SMMEs: "-",
      "VALUE CHAIN": "-",
      "TYPE OF FARMING": "-",
      "USER TYPE": "-"
    });
  
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const handleReportDropdownChange = (type, value) => {
      setReportSelections(prev => ({
          ...prev,
          [type]: value
      }));
      console.log("Report selection updated:", type, value);
  };
    const [selectedLanguage, setSelectedLanguage] = useState(null);
    console.log('Navigation URL:', `/ReportsRegistrationPage?country=${
        encodeURIComponent(
          typeof reportSelections.COUNTRY === 'object' 
            ? reportSelections.COUNTRY.name 
            : reportSelections.COUNTRY || "South Africa"
        )
      }`);
      const getSafeCountryName = (countryData) => {
        try {
          if (!countryData) return 'South Africa';
          if (typeof countryData === 'string') return countryData;
          if (typeof countryData === 'object' && countryData.name) return countryData.name;
          return 'South Africa';
        } catch (e) {
          console.error('Error parsing country data:', e);
          return 'South Africa';
        }
      };
    const handleLanguageChange = (lang) => {
        setSelectedLanguage(lang);
        console.log("Selected language:", lang);
    };
    const [formData, setFormData] = useState({
        firstName: "",
        surname: "",
        dateOfBirth: "",
        typeOfId: "",
        idNumber: "",
        mobile: "",
        email: "",
        password: "",
        whatsapp: "",
        physicalAddress: "",
        postalCode: "",
    });
    const [race, setRace] = useState("");
    const [gender, setGender] = useState("");
    const [disability, setDisability] = useState("");

    // Log all values here when Save is clicked in PersonalInfoForm
    const handlePersonalInfoSave = (data) => {
        console.log("Personal Info Form Data:", data);
    };

    const [orgFormData, setOrgFormData] = useState({
        cooperativeName: "",
        registrationNumber: "",
        members: "",
        mobileNumber: "",
        physicalAddress: "",
        chairFirstName: "",
        chairSurname: "",
        secretaryFirstName: "",
        secretarySurname: "",
        email: "",
        password: "",
    });
    const [orgType, setOrgType] = useState("COOPERATIVE 1");

    const handleOrgSave = (data) => {
        // This logs all org fields to the console
        console.log("Organization Form Data:", data);
    };

    const [loading, setLoading] = useState(false);
    const [progressMsg, setProgressMsg] = useState("");
    const [registrationError, setRegistrationError] = useState(null);
    const [registrationNumber, setRegistrationNumber] = useState("");
    const [showMembershipSections, setShowMembershipSections] = useState(false);
    const onHandleSave = async () => {
        setLoading(true);
        setProgressMsg("Saving...");
        setRegistrationError(null);
    
        try {
          let uid;
    
          if (isEditModalOpen) {
            // If the user is editing, use the existing UID from the logged-in user
            const user = auth.currentUser;
            if (!user) {
              throw new Error("User not logged in.");
            }
            uid = user.uid;
          } else {
            // Create Firebase Auth user (for new registration)
            const userCredential = await createUserWithEmailAndPassword(
              auth,
              formData.email,
              formData.password
            );
            uid = userCredential.user.uid;
            console.log("Firebase Auth user created:", userCredential.user);
          }
    
          // Generate Registration Number
          const regNumber = generateRegistrationNumber();
    
          // Build full data payload
          const registrationPayload = {
            registrationNumber: regNumber, // Make sure this is included
            userType: dropdownSelections.user_type,
            userPurpose: dropdownSelections.user_purpose,
            reportSelections,
            language: selectedLanguage,
            personalInfo: {
              ...formData,
              race, gender, disability
            },
            organizationInfo: {
              ...orgFormData,
              orgType,
              certificates: certificatesUrls,
              idDocument: idDocumentUrl,
            },
            background: { landType1, landType2, erfNumber },
            profingSkills: selectedSkills,
membership: selectedMembership || "",
            groupExperience: selectedExperience,
            sectionD: { focusSelected, selectedType, selectedOption, selectedCategories },
            industry: { selectedChallenges, vision },
            setaQualification: { selectedS, selectedQ },
            location,
            registrationNumber: regNumber,
            createdAt: new Date().toISOString(),
            uid,
          };
    
          console.log("Registration data to save:", registrationPayload);
    
          // Save to Firestore
          await setDoc(doc(db, "registrations", uid), registrationPayload);
    
          // Send email (for new registrations only)
          if (!isEditModalOpen) {
            await sendRegistrationEmail({
              user_name: formData.firstName + " " + formData.surname,
              registration_number: regNumber,
              user_email: formData.email,
              user_type: dropdownSelections.user_type,
              name: formData.firstName + " " + formData.surname,
              email: formData.email,
            });
            console.log("Registration email sent to:", formData.email, "with registration number:", regNumber);
          }
    
          // Finish
          setLoading(false);
          setRegistrationNumber(regNumber);
          setIsModalOpen(true);
        } catch (e) {
          setLoading(false);
    
          // Handle errors specifically for new registrations only
          if (!isEditModalOpen) { // <-- Ensure this only applies to new users
            let customErrorMessage = "An error occurred.";
            if (e.code === "auth/email-already-in-use") {
              customErrorMessage = "Error - Email already in use / taken";
            } else if (e.code === "auth/weak-password") {
              customErrorMessage = "Error - Password is too weak";
            } else if (e.code === "auth/invalid-email") {
              customErrorMessage = "Error - Invalid email address";
            }
            setRegistrationError(customErrorMessage);
          } else {
            console.error("Error during edit:", e);
          }
        }
      };
    // Load saved data from local storage on component mount
    useEffect(() => {
        const savedData = JSON.parse(localStorage.getItem("registrationData"));
        if (savedData) {
            setFormData(savedData.formData || {});
            setOrgFormData(savedData.orgFormData || {});
            setDropdownSelections(savedData.dropdownSelections || {});
            setReportSelections(
                savedData.reportSelections || initialReportSelections,
            );
            setSelectedLanguage(savedData.selectedLanguage || null);
            setLandType1(savedData.landType1 || "");
            setLandType2(savedData.landType2 || "");
            setErfNumber(savedData.erfNumber || "");
            setSelectedSkills(savedData.selectedSkills || []);
            setSelectedMembership(savedData.selectedMembership || "");
            setSelectedExperience(savedData.selectedExperience || []);
            setFocusSelected(savedData.focusSelected || []);
            setSelectedType(savedData.selectedType || "");
            setSelectedOption(savedData.selectedOption || "Maize");
            setSelectedCategories(savedData.selectedCategories || []);
            setSelectedChallenges(savedData.selectedChallenges || []);
            setVision(savedData.vision || "");
            setSelectedS(savedData.selectedS || "Agri");
            setSelectedQ(savedData.selectedQ || "Business Administration");
            setLocation(savedData.location || null);
        }
    }, []);
    const pdfPreviewRef = useRef(null);
    const validateForm = () => {
        const requiredFields = [
          'firstName', 'surname', 
          'idNumber', 'mobile', 
          'email', 'password'
        ];
        
        for (const field of requiredFields) {
          if (!formData[field]?.trim()) {
            setRegistrationError(`Please fill in ${field.replace(/([A-Z])/g, ' $1').toLowerCase()}`);
            return false;
          }
        }
      
        // Email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.email)) {
          setRegistrationError("Please enter a valid email address");
          return false;
        }
      
        // Password length
        if (formData.password.length < 6) {
          setRegistrationError("Password must be at least 6 characters long");
          return false;
        }
      
        // Terms agreement
        if (!agreed) {
          setShowAgreementError(true);
          setRegistrationError("Please agree to the terms and conditions");
          return false;
        }
      
        return true;
      };
      useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
          if (user) {
            console.log("Logged in user:", user.uid);
          } else {
            console.log("No user logged in");
          }
        });
      
        return () => unsubscribe();
      }, []);
      
      // Update the register button click handler
 
      console.log('Current country selection:', reportSelections.COUNTRY);
console.log('Generated URL:', `/ReportsRegistrationPage?country=${encodeURIComponent(reportSelections.COUNTRY)}`);
      // Update the register button click handler
      const handleRegisterClick = async () => {
        console.log("Starting registration process...");
        
        if (!validateForm()) {
          console.log("Form validation failed");
          return;
        }
        
        try {
          console.log("Attempting registration...");
          await handleRegister();
          console.log("Registration attempt completed");
        } catch (error) {
          console.error("Registration failed with error:", {
            name: error.name,
            message: error.message,
            stack: error.stack,
            code: error.code
          });
          setRegistrationError("Registration failed. Please try again.");
        }
      };
      // Add this near the top of your component
useEffect(() => {
    // Debug logged when form data changes
    console.log("Current form data:", formData);
    console.log("Current org data:", orgFormData);
    console.log("Current dropdown selections:", dropdownSelections);
  }, [formData, orgFormData, dropdownSelections]);
  
  // Add this to your registration function
  const debugRegistration = (payload) => {
    console.group("Registration Payload");
    console.log("User data:", payload);
    console.log("Auth state:", auth.currentUser);
    console.log("Form validation:", validateForm());
    console.groupEnd();
  };
    // Example: Reset error when typing in the email or password fields
    const handleFormInputChange = (field, value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: value,
        }));
        setRegistrationError(null); // Clear the error when the user starts typing
    };
    useEffect(() => {
      if (selectedCountry && selectedCountry.name !== reportSelections.COUNTRY?.name) {
        setReportSelections(prev => ({
          ...prev,
          COUNTRY: selectedCountry
        }));
      }
    }, [selectedCountry]);
  
    return (
        <div className="bg-white">
            <div className="md:px-28 px-4">
                {/* Header Section */}
                <div className="w-full mx-auto md:pt-12 pt-4">
                <div className="flex items-center md:w-[1000px] ">
                <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748272080/FarmNet_Logo_Green_4_fepmyi.png" alt="hi" className="md:w-[250px] md:h-[40px] h-[15px] w-[100px]"/>
               <h2 className="text-center font-bold  text-[14px]  md:text-[54px] flex-1 flex  justify-center items-center">
                    REGISTRATION
                    </h2>
                </div>
                    <div className="md:mt-5 mt-3 relative">
                        <div className="relative">
                            <img
                                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745662169/image_34_nw6w6z.png"
                                alt="Farmland"
                                className="w-full object-cover md:h-[400px]"
                            />
                            <img
                                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745662260/image_1716_vhpofl.png"
                                alt="FarmNet Logo"
                                className="absolute md:bottom-4 left-3 bottom-1 md:left-8 md:w-[170px] w-[80px] h-auto"
                            />
                        </div>
                      
                    </div>
                    <h1 className="text-[#979797] md:text-[36px] text-[14px] font-bold md:mt-6 mt-3 md:mb-6">
                        REGISTRATION{" "}
                        <span className="text-[#152C24]">| INDIVIDUAL</span>
                    </h1>
             <div className="flex justify-between items-center w-full md:mt-4">
             
                    <div>
                    <a href={`/ReportsRegistrationPage?country=${encodeURIComponent(
  typeof reportSelections.COUNTRY === 'object' 
    ? reportSelections.COUNTRY.name 
    : reportSelections.COUNTRY || "South Africa"
)}`}>
  <div>
    <div className="flex w-fit md:mt-3">
      <button className={`xl:w-[250px] lg:w-[140px] md:w-[90px] w-[50px] h-[15px] md:h-[53px] bg-[#2E453D] text-white font-medium flex items-center px-1 rounded-l-[5px]`}>
        <span className="md:text-[18px] md:px-2 text-[4px] md:mt-0 mt-[2px] truncate">REPORTS</span>
      </button>
      <div className="w-[15px] h-[15px] md:h-[53px] md:w-[37px] bg-[#152C24] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer">
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747251939/Expand_right_wbmjno.png"
          alt="expand"
          className="w-2 h-[10px] md:w-6 md:h-[24px]"
        />
      </div>
    </div>
    <p className="md:text-[14px] text-[4px] font-normal mt-1 text-black">
      Click to run reports selected
    </p>
  </div>
</a>
      </div>
  <div className="flex items-center gap-2">
  <div className="w-auto">
    <Dropdown1
      label="LANGUAGE"
      items={language.FACILITATOR}
      type="FACILITATOR"
      isLanguageDropdown={false}
      onChange={handleDropdownChange}
    />
  </div>
  <div>
  <h1 className="md:text-[20px] text-[6px] font-extrabold md:mb-2 ">USER NUMBER</h1>
      <div className="flex w-fit">
                <button
                 
                    className={`xl:w-[250px] lg:w-[160px] md:w-[90px] w-[50px] h-[15px] md:h-[53px] bg-[#152C24] text-white font-medium flex items-center px-1 rounded-l-[5px]`}>
                    <input className="md:text-[18px] md:px-2 text-[4px] md:mt-0 mt-[2px] bg-transparent outline-none placeholder-white" placeholder="XXXXXXXXX"/>

                    
                </button>
                <div
                    className="w-[15px] h-[15px] md:h-[53px] md:w-[50px] bg-[#EEB527] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer"
                 >
                    <img
                        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747251939/Expand_right_wbmjno.png"
                        alt="expand"
                        className="w-2 h-[10px] md:w-6 md:h-[24px]"
                    />
                </div>
            </div>
            <p className="md:text-[14px] text-[4px] font-normal mt-1 text-black">
            Insert ID Number
            </p>

      </div>
   
  </div>
             </div>
                </div>

                <div className=" w-full  mx-auto md:pt-1 pt-2">
                    {/* Labels directly above the bar */}
                    <div>
                        <div className="relative w-full mx-auto h-[40px] md:mb-4 md:mt-3 mb-0">
                            <span
                                className={`absolute top-0 left-[25%] sm:left-[25%] -translate-x-1/2 text-[8px] sm:text-[36px] font-bold cursor-pointer transition-colors duration-200 ${
                                    selected3 === "Individual"
                                        ? "text-black"
                                        : "text-black"
                                }`}
                                onClick={() => setSelected3("Individual")}>
                                Individual
                            </span>

                            <a href="/RegisterOrganizaton">
                                <span
                                    className={`absolute top-0 left-[75%] sm:left-[75%] -translate-x-1/2 text-[8px] sm:text-[36px] font-bold cursor-pointer transition-colors duration-200 ${
                                        selected3 === "Organization"
                                            ? "text-black"
                                            : "text-black"
                                    }`}
                                    onClick={() => setSelected3("Organization")}>
                                    Organization
                                </span>
                            </a>
                        </div>

                        {/* Toggle Bar */}
                        <div className="w-full md:h-[10px] h-[4px] bg-[#D9D9D9] flex rounded-[10px] overflow-hidden md:mt-0 mb-2 -mt-5 md:mb-6 mx-auto">
                            {/* Individual Side */}
                            <div
                                className="w-1/2 h-full cursor-pointer relative"
                                onClick={() => setSelected3("Individual")}>
                                <div
                                    className={`absolute inset-0 transition-all duration-300 ${
                                        selected3 === "Individual"
                                            ? "bg-[#152C24]"
                                            : "bg-[#D9D9D9]"
                                    } rounded-[10px]`}></div>
                            </div>

                            {/* Organization Side */}
                            <a href="/RegisterOrganization">
                                <div
                                    className="w-1/2 h-full cursor-pointer relative"
                                    onClick={() => setSelected3("Organization")}>
                                    <div
                                        className={`absolute inset-0 transition-all duration-300 ${
                                            selected3 === "Organization"
                                                ? "bg-[#152C24]"
                                                : "bg-[#D9D9D9]"
                                        } rounded-[10px]`}></div>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div className="flex justify-between items-center w-full ">
                        {/* LEFT SIDE - HEADING */}
                        <div>
                            <div className="flex-1 md:mt-12">
                                <div>
                                    <div className="flex md:flex-row items-start md:gap-4 gap-1 ">
                                        <a href="/SMEChallenges">
                                            <div className="md:w-[300px] w-[80px] md:max-w-[310px]">
                                                <button className="w-full h-[20px] text-black md:h-[60px] text-left rounded-[5px] px-1 md:px-2 bg-[#E7EBEB] border-b-[4px] border-[#EEB527] text-[5px] md:text-[20px] font-bold">
                                                FARMERS CHALLENGES
                                                </button>
                                                <p className="text-[4px] md:text-[16px] leading-tight font-normal mt-1">
                                                    Click to read entrepreneurs{" "}
                                                    <br /> challenges
                                                </p>
                                            </div>
                                        </a>

                                        <div className="md:w-full w-[80px] md:max-w-[300px]">
                                            <a href="/BenefitsOfRegistration">
                                                <button className="w-full h-[20px]  text-black md:h-[60px] text-left px-1 md:px-2 rounded-[5px] bg-[#E7EBEB] border-b-[4px] border-[#EEB527] text-[5px] md:text-[20px] font-bold">
                                                BENEFITS OF REGISTRATION
                                                </button>
                                            </a>
                                            <p className="text-[4px] md:text-[16px] font-normal mt-1">
                                                Click to read benefits of
                                                registration
                                                <br />
                                                <span className="text-transparent">
                                                    sss
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* RIGHT SIDE - DROPDOWNS */}
                        <div className="flex gap-4 flex-wrap justify-end md:-mt-5 ">
                            {keys.map((type, index) => {
                                const customLabels = {
                                    Crop: "Crop Report",
                                    Livestock: "Livestock Report",
                                    Type: "Type of Report",
                                };

                                const displayLabel = customLabels[type] || type;
                                const isProjectDropdown =
                                    index === keys.length - 1;

                                return (
                                    <div key={type} className="w-auto">
                                        <Dropdown
                                            label={displayLabel}
                                            items={dropdownItems[type]}
                                            type={type}
                                            isProjectDropdown={isProjectDropdown}
                                            onChange={handleDropdownChange}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                  
                    <ReportsSection
  values={reportSelections}
  onChange={handleReportDropdownChange}
  smmesOptions={SMMEsOptions}
  selectedCountry={selectedCountry} // Pass the selectedCountry from context
/>
<div className="flex items-center w-full">
  {/* Image on the far left */}
  <img
    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747492690/image_1746_yjxha4.png"
    alt="Registration Icon"
    
    className="ml-4 md:w-[79px] md:h-[78px] w-[25px] h-[25px]"
  />

  {/* Spacer to push the text to center */}
  <div className="flex flex-col flex-grow items-center">
  <h1 className="md:text-[48px] font-bold text-[#152C24] text-center">
  {reportSelections.COUNTRY !== "South Africa" // Only show if country is selected (and not default)
    ? generateRegistrationNumber({
        COUNTRY: reportSelections.COUNTRY,
        REGION: reportSelections.REGION || "--",
        DISTRICT: reportSelections.DISTRICT || "--",
        MUNICIPALITY: reportSelections.MUNICIPALITY || "--", 
        SMMEs: reportSelections.SMMEs?.value || "--",
        "USER TYPE": reportSelections["USER TYPE"] // This comes from ReportsSection
      })
    : "XXXXXXXXXXXXXXXXXXXX"}
</h1>
  <p className="md:text-[16px] font-normal w-full text-[6px] text-center mt-1">
    User Registration Number Preview
  </p>
</div>
</div>                 {/* 
          <OfficialNews /> */}
                </div>
                <PersonalInfoForm
                    formData={formData}
                    onFormDataChange={setFormData}
                    race={race}
                    onRaceChange={setRace}
                    gender={gender}
                    onGenderChange={setGender}
                    disability={disability}
                    onDisabilityChange={setDisability}
                    onSave={handlePersonalInfoSave}
                />
                <div>
                  
                  <p className="md:text-[32px] text-[8px] font-medium text-black">
                <span className="text-[#FDBD26] font-bold">*Optional: </span>Please click the dropdown arrow in each section and complete all required fields to qualify for support from providers. Thank you.
                  </p>
            
<div className="w-full md:h-[133px] h-[70px] flex items-center justify-between border-b border-[#979797] bg-white rounded-b-[1px] rounded-[10px] relative">
  {/* Left placeholder for spacing */}
  <div className="w-[154px] h-[70px] sm:w-[100px] sm:h-[100px]"></div>

  {/* Centered Text */}
  <div className="absolute left-1/2 transform -translate-x-1/2 md:text-[32px] text-[8px] font-bold">
    PROFILE
  </div>

  {/* Right Box - Toggle Button */}
  <div 
    className="md:w-[154px] md:h-[133px] w-[100px] h-[70px] bg-[#D9D9D9] rounded-br-[10px] flex items-center justify-center border-b border-black cursor-pointer"
    onClick={() => setShowProfileSections(!showProfileSections)}
  >
    <img
      src={`https://res.cloudinary.com/dzngpgki4/image/upload/${showProfileSections ? 'v1748785688/Expand_down_yilqh4.png' : 'v1748785688/Expand_down_yilqh4.png'}`}
      alt="expand icon"
      className="md:w-12 md:h-12 w-6 h-6"
    />
  </div>
</div>


                </div>
                {showProfileSections && (
  <>
    <Profile
      formData={orgFormData}
      onProfileImageChange={(imageData) => {
        setProfileImage(imageData);
        setFormData(prev => ({
          ...prev,
          profileImage: imageData.cloudinaryUrl || imageData.previewUrl
        }));
      }}
      onIdUrlChange={setIdDocumentUrl}
      onSave={setOrgFormData}
    />
    
    <ProductService
      formData={orgFormData}
      onProductImagesChange={setProductImages}
      onIdUrlChange={setIdDocumentUrl}
      onSave={setOrgFormData}
    />
    
    <OrganizationForm
      formData={orgFormData}
      onFormDataChange={setOrgFormData}
      selectedOption={orgType}
      onOptionChange={setOrgType}
      onCertificatesUrlsChange={setCertificatesUrls}
      onIdUrlChange={setIdDocumentUrl}
      onSave={setOrgFormData}
    />
  </>
)}


<BackgroundInfoSection
  languages={languages}
  languages1={languages1}
  selected={landData.type1?.type}
  setSelected={(type) => setLandData(prev => ({
    ...prev,
    type1: { ...prev.type1, type }
  }))}
  selected1={landData.type2?.type}
  setSelected1={(type) => setLandData(prev => ({
    ...prev,
    type2: { ...prev.type2, type }
  }))}
  erfNumber={landData.erfNumber}
  setErfNumber={(number) => setLandData(prev => ({
    ...prev,
    erfNumber: number
  }))}
  onSave={(data) => {
    console.log("Land data saved:", data);
    setLandData(data);
  }}
  showError={showBackgroundError}
/>
                <div></div>

                <div>
                <div className="md:mt-5 mt-2 w-full md:h-[133px] h-[70px] flex items-center justify-between border-b border-[#979797] bg-white rounded-b-[1px] rounded-[10px] relative">
  {/* Left placeholder for spacing */}
  <div className="w-[154px] h-[70px] sm:w-[100px] sm:h-[100px]"></div>

  {/* Centered Text */}
  <div className="absolute md:text-[32px] text-[20px] font-bold">
    <div>
      <h3 className="font-bold text-black text-[8px] md:text-[32px]">
        Memberships, Affiliations, Groups and Associations
      </h3>
      <p className="md:text-[24px] text-[6px] italic font-normal leading-[0.58] mt-1 text-black">
        What other organization groups or affiliations are <div className="md:hidden flex"> <br/></div> you a member of, or are involved with:
      </p>
    </div>
  </div>

  {/* Right Box - Toggle Button */}
  <div 
    className="md:w-[154px] md:h-[133px] w-[100px] h-[70px] bg-[#D9D9D9] rounded-br-[10px] flex items-center justify-center border-b border-black cursor-pointer"
    onClick={() => setShowMembershipSections(!showMembershipSections)}
  >
    <img
      src={`https://res.cloudinary.com/dzngpgki4/image/upload/${showMembershipSections ? 'v1748785688/Expand_down_yilqh4.png' : 'v1748785688/Expand_down_yilqh4.png'}`}
      alt="expand icon"
      className="md:w-12 md:h-12 w-6 h-6"
    />
  </div>
</div>
{showMembershipSections && (
  <>
    <MembershipSection
      selectedMembership={membershipData.selected}
      setSelectedMembership={(value) =>
        setMembershipData((prev) => ({ ...prev, selected: value }))
      }
      onSave={(data) => {
        if (data.type === 'selected') {
          setFormData(prev => ({ ...prev, selectedMembership: data.value }));
        } else if (data.type === 'custom') {
          setFormData(prev => ({ ...prev, customMembership: data.value }));
        }
      }} 
    />

    <GroupExperience
      selectedExperience={selectedExperience}
      setSelectedExperience={setSelectedExperience}
      onSave={(data) => {
        console.log("Group Experience Data:", data);
        setSelectedExperience(data.selectedExperience);
      }}
    />
  </>
)}
                    <SectionDnew
                        selected={focusSelected}
                        setSelected={setFocusSelected}
                        selectedType={selectedType}
                        setSelectedType={setSelectedType}
                        onSave={handleFocusSave}
                    />
                
                <div 
  className="w-full md:mt-5 mt-3  md:h-[133px] h-[70px] flex items-center justify-between border-b border-[#979797] bg-white rounded-b-[1px] rounded-[10px] md:mt-7 relative cursor-pointer"
  onClick={toggleExpand}
>
  <div className="w-[154px] h-[70px] sm:w-[70px] sm:h-[100px]"></div>
  <div className="absolute left-1/2 transform -translate-x-1/2 md:text-[32px] text-center text-[8px] font-bold">
    INDUSTRY ACTIVITY SURVEY
  </div>
  <div className="md:w-[154px] md:h-[133px] w-[100px] h-[70px] bg-[#D9D9D9] rounded-br-[10px] flex items-center justify-center border-b border-black">
    <img
      src={`https://res.cloudinary.com/dzngpgki4/image/upload/${
        isExpanded 
          ? 'v1748785688/Expand_down_yilqh4.png' 
          : 'v1748785688/Expand_down_yilqh4.png'
      }`}
      alt="expand icon"
      className="md:w-12 md:h-12 w-6 h-6"
    />
  </div>
</div>

{isExpanded && (
  <>
    <IndustrySection
      selected={selectedChallenges}
      setSelected={setSelectedChallenges}
      vision={vision}
      setVision={setVision}
      onSave={(data) => {
          console.log("Industry data saved:", data);
          setSelectedChallenges(data.selectedChallenges);
          setVision(data.vision);
      }}
    />
    
    {/* Location Section */}
    <div className="md:mt-3 flex items-center space-x-3">
      <img
        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744662306/image_1570_pnbwi8.png"
        alt=".."
        className="md:w-[37px] w-[17px] h-[17px] md:h-[37px]"
      />
      <h1 className="md:text-[36px] text-[10px] font-bold">
        Set Location
      </h1>
    </div>
    <div className="h-auto w-full rounded-md mt-3">
      <LocationPicker onSaveLocation={handleSaveLocation} />
    </div>
  </>
)}

<SaveButtonWithModal />
                        <div>
                            {/* Checkbox Box */}
                 
                            <div className="flex gap-4 items-center mt-5">
                                <div
                                    className="md:w-16 md:h-[63px] w-6 h-[30px] rounded-[5px] bg-[#D9D9D9] flex items-center justify-center cursor-pointer transition"
                                    onClick={() => {
                                        setAgreed((prev) => !prev);
                                        setShowAgreementError(false); // Clear error when checkbox is clicked
                                    }}
                                    tabIndex={0}
                                    aria-pressed={agreed}
                                    aria-label="Confirm terms and conditions">
                                    {/* Black or Green Check Round Fill SVG */}
                                    {agreed ? (
                                        // GREEN CHECK ROUND FILL
                                        <svg
                                            width="54"
                                            height="54"
                                            viewBox="0 0 54 54"
                                            fill="none"
                                            className="md:w-[54px] md:h-[54px] w-[20px] h-[20px] transition-all duration-150"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <circle
                                                cx="27"
                                                cy="27"
                                                r="27"
                                                fill="#152C24"
                                            />
                                            <path
                                                d="M39 21L24.75 35L15 25.4545"
                                                stroke="white"
                                                strokeWidth="4"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    ) : (
                                        // BLACK CHECK ROUND FILL
                                        <svg
                                            width="54"
                                            height="54"
                                            viewBox="0 0 54 54"
                                            fill="none"
                                            className="md:w-[54px] md:h-[54px] w-[20px] h-[20px] transition-all duration-150"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <circle
                                                cx="27"
                                                cy="27"
                                                r="27"
                                                fill="#222"
                                            />
                                            <path
                                                d="M39 21L24.75 35L15 25.4545"
                                                stroke="white"
                                                strokeWidth="4"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    )}
                                </div>
                                <p className="md:text-[20px] text-[6px]">
                                    By ticking I confirm that I agree with the{" "}
                                    <a
                                        className="underline hover:text-[#152C24]"
                                        href="/TermsAndCondition">
                                        Terms and conditions
                                    </a>
                                    ,<a href="/DataPolicy"     className="underline hover:text-[#152C24]">Data </a>and{" "}
                                    <a
                                        className="underline hover:text-[#152C24]"
                                        href="/PrivacyPolicy">
                                        Privacy policy
                                    </a>
                                    .
                                       <p
                                className={`md:text-[14px] text-[10px] ${
                                    agreed
                                        ? "text-white hidden "
                                        : " text-red-600 cursor-not-allowed"
                                }`}>
                                Please agree to the terms and conditions before
                                proceeding.
                            </p>
                                </p>

                         

                            {/* Text */}
                        </div>
                 
                    </div>

                    {/* Register Button */}
                    {/* Register Button */}
                    <button
  onClick={handleRegisterClick}
  disabled={loading || !agreed}
  className={`w-full flex justify-center md:text-[28px] text-[8px] mt-1 font-bold items-center md:mt-14 border-b-[3px] md:py-1 py-1 text-center md:h-[74px] h-[20px] ${
    agreed && !loading
      ? "bg-[#152C24] text-white border-[#FDBD26]"
      : "bg-gray-400 text-gray-200 border-gray-300 cursor-not-allowed"
  }`}
>
  {loading ? "Processing..." : "Register"}
</button>
       <div className="flex flex-col justify-end  ">
                                {/* Buttons */}
                                <div className="flex md:gap-4 gap-1  justify-end mt-2">

                                 {/* Save Button */}
                                 <div>
                                        {/* Save Button */}
                                        {/* Delete Button */}
<div>
    <button
        className="flex items-center justify-between w-[60px] md:w-[190px] h-[15px] md:h-[44px] bg-[#FDBB26] text-white md:text-[14px] text-[6px] font-bold rounded-[5px] px-1 md:px-4"
        onClick={() => setIsDeleteModalOpen(true)}>
        <span>DELETE</span>
        <img 
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748279697/Trash_1_afo0yz.png" 
            alt="Delete" 
            className="md:w-[30px] h-[6px] md:h-[30px] w-[6px]"
        />
    </button>
    <p className="md:text-[14px] text-[6px] mt-1 font-normal md:px-1">
        Delete registration 
    </p>
</div>

                                        {/* Save Confirmation Modal */}
                                       {/* Delete Confirmation Modal */}
<Modal
    isOpen={isDeleteModalOpen}
    onRequestClose={() => setIsDeleteModalOpen(false)}
    contentLabel="Delete Confirmation"
    className="modal-content"
    overlayClassName="modal-overlay">
    <button
        onClick={() => setIsDeleteModalOpen(false)}
        className="absolute top-1 right-4 text-black opacity-30 hover:text-black text-[30px] font-light z-50"
        aria-label="Close">
        &times;
    </button>
    <div>
        <div className="relative bg-white p-0 rounded-lg w-[350px] md:w-[800px] mx-auto md:h-[430px]">
            <div className="flex flex-col items-center justify-center text-center w-[300px]  h-full md:w-full">
                <div className="relative mb-4 w-full flex justify-center items-center">
                    <img
                        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748279697/Trash_1_afo0yz.png"
                        alt="Delete"
                        className="w-[24px] h-[24px] md:w-[60px] md:h-[60px]"
                    />
                </div>
                <div className="text-[16px] md:text-[48px] font-bold text-center w-full">
                    Confirm Deletion
                </div>
                <p className="text-black text-[10px] md:text-[32px] mb-2">
                    Are you sure you want to delete this registration?
                </p>
                <p className="text-black text-[10px] md:text-[24px] mb-6">
                    This action cannot be undone.
                </p>
                <div className="flex gap-4 w-full justify-center">
                    <button
                        onClick={() => setIsDeleteModalOpen(false)}
                        className="bg-gray-300 hover:bg-gray-400 text-[12px] md:text-[32px] text-black w-[130px] md:w-[300px] h-[40px] md:h-[56px] px-5 py-1 rounded-md font-bold">
                        Cancel
                    </button>
                    <button
  onClick={() => {
    clearAllFormData();
    setIsDeleteModalOpen(false);
  }}
  className="bg-red-500 hover:bg-red-600 text-[12px] md:text-[32px] text-white  w-[130px] md:w-[300px] h-[40px] md:h-[56px] px-5 py-1 rounded-md font-bold">
  Delete
</button>
                </div>
            </div>
        </div>
    </div>
</Modal>

                                        {/* Registration Confirmation Modal */}
                                        <Modal
                                            isOpen={isRegisterModalOpen}
                                            onRequestClose={closeRegisterModal}
                                            contentLabel="Registration Successful"
                                            className="modal-content"
                                            overlayClassName="modal-overlay">
                                            <button
                                                onClick={closeRegisterModal}
                                                className="absolute top-1 right-4 text-black opacity-30 hover:text-black text-[30px] font-light z-50"
                                                aria-label="Close">
                                                &times;
                                            </button>
                                            <div>
                                                <div className="relative bg-white p-0 rounded-lg w-[350px] md:w-[800px] mx-auto md:h-[430px]">
                                                    <div className="flex flex-col items-center justify-center text-center h-full w-full">
                                                        <div className="relative mb-4 w-full flex justify-center items-center">
                                                            <img
                                                                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746440276/image_72_ifcxcp.png"
                                                                alt="Success"
                                                                className="absolute left-2 top-1/2 transform -translate-y-1/2 w-[24px] h-[24px] md:w-[60px] md:h-[60px]"
                                                            />
                                                            <div className="text-[16px] md:text-[48px] font-bold text-center w-full">
                                                                Registration
                                                                Successful
                                                            </div>
                                                        </div>
                                                        <p className="text-black text-[10px] md:text-[32px] mb-2">
                                                            Thank you for
                                                            registering with
                                                            Farmnet
                                                        </p>
                                                        <p className="text-black text-[10px] md:text-[32px] mb-4">
                                                            Your unique
                                                            registration number
                                                            is:
                                                        </p>
                                                        <div className="flex items-center justify-between w-full mb-1 mt-8 px-4">
                                                            <div className="flex-1 flex justify-center">
                                                                <span className="text-[12px] md:text-[32px] font-bold text-center md:ml-32 ml-5 tracking-wide">
                                                                    {
                                                                        registrationNumber
                                                                    }
                                                                </span>
                                                            </div>
                                                            <button
                                                                onClick={() => {
                                                                    navigator.clipboard.writeText(
                                                                        registrationNumber,
                                                                    );
                                                                    setCopyMessage(
                                                                        "Copied!",
                                                                    );
                                                                    setTimeout(
                                                                        () =>
                                                                            setCopyMessage(
                                                                                "",
                                                                            ),
                                                                        2000,
                                                                    );
                                                                }}
                                                                className="bg-[#F38323] hover:bg-orange-600 text-white font-light text-[10px] md:text-[32px] md:w-[140px] md:h-[60px] px-4 py-2 rounded-[10px]">
                                                                Copy
                                                            </button>
                                                        </div>
                                                        {copyMessage && (
                                                            <div className="text-black text-[14px] md:text-[18px] font-semibold">
                                                                {copyMessage}
                                                            </div>
                                                        )}
                                                        <a href="/">
                                                            <button
                                                                onClick={
                                                                    closeRegisterModal
                                                                }
                                                                className="bg-[#03897B] md:mt-3 hover:bg-[#1b4a46] text-[12px] md:text-[32px] text-white w-full md:w-[500px] h-[40px] md:h-[56px] px-5 py-1 rounded-md font-bold">
                                                                Continue to Homes
                                                            </button>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </Modal>
                                    </div>
                                    {/* Edit Button */}
                                    <div>
                                        <button
                                            className="flex items-center justify-between md:w-[190px] w-[60px] md:h-[44px] h-[15px] bg-[#2E453D] text-white md:text-[14px] md:px-4 px-1 text-[6px] font-bold rounded-[5px]"
                                            onClick={() =>
                                                setIsEditModalOpen(true)
                                            }>
                                            <span>EDIT</span>
                                            <img
                                                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745690463/Edit_fill_llaa3q.png"
                                                alt="Edit Icon"
                                                className="md:w-[30px] h-2  md:h-[30px] w-2"
                                            />
                                        </button>

                                        <p className="md:text-[14px] text-[6px]  mt-1 font-normal md:px-1 ">
                                            Edit registration form
                                        </p>
                                        <Modal
                                            isOpen={isEditModalOpen}
                                            onRequestClose={() =>
                                                setIsEditModalOpen(false)
                                            }
                                            contentLabel="Login to Edit"
                                            className="modal-content bg-[#E7EBEB]  w-[350px] md:w-[600px]"
                                            overlayClassName="modal-overlay ">
                                            {/* Close Button */}
                                            <button
                                                onClick={() =>
                                                    setIsEditModalOpen(false)
                                                }
                                                className="absolute top-2 right-2 md:top-4 md:right-4 text-black opacity-50 hover:opacity-100 text-[12px] md:text-[30px] font-bold z-50"
                                                aria-label="Close">
                                                &times;
                                            </button>
<div className="flex justify-end"> 
    <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748281140/image_aorywu.png" alt="hi" className="md:w-[120px] md:mt-10 md:h-[22px]"/>
</div>
                                            <div className="md:p-4 p-2 md:py-20">
                                                <h2 className=" md:text-[40px] font-extrabold mb-4">
                                                Farm IT , Digitalize IT!

                                                </h2>
                                                <div>
                                                 
                                                    <input
                                                        type="email"
                                                        value={loginEmail}
                                                        placeholder="Enter Email address"
                                                        onChange={(e) =>
                                                            setLoginEmail(
                                                                e.target.value,
                                                            )
                                                        }
                                                        className="w-full text-[10px] shadow-inner shadow-black/40 md:text-[20px] bg-[#152C24] focus:bg-[#152C24] text-white placeholder:text-white placeholder:font-bold rounded-md placeholder:pl-1 mb-4 p-2 h-[48px] md:h-[66px]  md:px-6 "
                                                    />
                                                </div>
                                                <div className="mt-2">
                                                   
                                                    <input
                                                        type="password"
                                                        value={loginPassword}
                                                        placeholder="Enter password"
                                                        onChange={(e) =>
                                                            setLoginPassword(
                                                                e.target.value,
                                                            )
                                                        }
                                              className="w-full text-[10px] inner-shadow shadow-black md:text-[20px] bg-[#152C24] focus:bg-[#152C24] text-white placeholder:text-white placeholder:font-bold rounded-md placeholder:pl-1 mb-4 p-2 h-[48px] md:h-[66px]  md:px-6 "
                                                    />
                                                </div>
                                                {loginError && (
                                                    <p className="text-red-500 text-sm mt-2">
                                                        {loginError}
                                                    </p>
                                                )}
                                                {isLoggedIn && (
                                                    <p className="text-green-500 text-sm mt-2">
                                                        Login successful!
                                                    </p>
                                                )}
                                                <div className="mt-6 flex justify-between gap-3 md:gap-8">
                                                    <button
                                                        onClick={() =>
                                                            setIsEditModalOpen(
                                                                false,
                                                            )
                                                        }
                                                        className="bg-gray-300  shadow-inner shadow-black/40 font-bold  text-black text-[8px] md:text-[20px] w-full px-4 md:py-4 py-2 rounded-md">
                                                        Cancel
                                                    </button>
                                                    <button
                                                        onClick={handleLogin}
                                                        className="bg-[#FDBB26]  shadow-inner shadow-black/40 font-bold md:text-[20px] text-[8px] text-white w-full px-4 md:py-4 rounded-md">
                                                        {loading
                                                            ? "Logging in..."
                                                            : "Login"}
                                                    </button>
                                                </div>
                                            </div>
                                        </Modal>
                                    </div>

                                    {/* Save Button */}
                                    <div>
                                        {/* Save Button */}
                                        <div>
                                            <button
                                                className="flex items-center justify-between w-[60px] md:w-[190px] h-[15px] md:h-[44px] bg-[#2E453D] text-white md:text-[14px] text-[6px] font-bold rounded-[5px] px-1 md:px-4"
                                                onClick={handleSaveClick}>
                                                <span>SAVE ALL</span>
                                                <img
                                                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748279791/Arhive_load_duotone_line_ukwrm4.png"
                                                alt="Edit Icon"
                                                className="md:w-[30px] h-[6px]  md:h-[30px] w-[6px]"
                                            />
                                            </button>
                                            <p className="md:text-[14px] text-[6px]  mt-1 font-normal md:px-1">
                                                Save registration
                                            </p>
                                        </div>

                                        {/* Save Confirmation Modal */}
                                        <Modal
                                            isOpen={isSaveModalOpen}
                                            onRequestClose={closeSaveModal}
                                            contentLabel="Save Successful"
                                            className="modal-content"
                                            overlayClassName="modal-overlay">
                                            <button
                                                onClick={closeSaveModal}
                                                className="absolute top-1 right-4 text-black opacity-30 hover:text-black text-[30px] font-light z-50"
                                                aria-label="Close">
                                                &times;
                                            </button>
                                            <div>
                                            <div className="relative bg-white p-0 rounded-lg w-[350px] md:w-[800px] mx-auto md:py-0 py-2 md:h-[430px] flex flex-col items-center justify-center">

                                                    <div >
                                                        <div className="relative mb-4 w-full ">
                                                      
                                                            <div className="text-[14px] md:text-[48px] font-bold text-center w-full">
                                                                Save Successful
                                                            </div>
                                                        </div>
                                                        <p className="text-black text-[10px] md:text-[32px]  text-center mb-2">
                                                            The registration form
                                                            has been successfully
                                                            saved.
                                                        </p>
                                                        <button
                                                            onClick={
                                                                closeSaveModal
                                                            }
                                                            className="bg-[#152C24] md:mt-3 hover:bg-[#1b4a46] text-[10px] md:text-[32px] text-white w-[320px] md:w-[700px] h-[30px] md:h-[56px] px-5 py-1 rounded-md font-bold">
                                                            Close
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </Modal>

                                        {/* Registration Confirmation Modal */}
                                        
                                    </div>


<a 
  href="#" 
  onClick={(e) => {
    e.preventDefault();
    const selectedChallengeObjects = challengesData.filter(challenge => 
      selectedChallenges.includes(challenge.id)
    );
    navigate('/document', {
      state: {
        personalInfo: formData,
        organizationInfo: orgFormData,
        dropdownSelections,
        reportSelections: {
          COUNTRY: reportSelections.COUNTRY,
          REGION: reportSelections.REGION,
          DISTRICT: reportSelections.DISTRICT,
          MUNICIPALITY: reportSelections.MUNICIPALITY,
          SMMEs: reportSelections.SMMEs,
          "VALUE CHAIN": reportSelections["VALUE CHAIN"],
          "TYPE OF FARMING": reportSelections["TYPE OF FARMING"],
          "USER TYPE": reportSelections["USER TYPE"]
        },
        selectedLanguage,
        landData,
        selectedSkills,
        membershipData,
        selectedExperience,
        focusSelected,
        sectionD: {
          selectedType,
          selectedOption,
          selectedCategories
        },
   industry: { 
          selectedChallenges: selectedChallengeObjects,
          vision: vision
        },
        setaQualification: {
          selectedS,
          selectedQ
        },
        location: userLocation,
        registrationNumber,
        idDocumentUrl,
        profileImage,
        productImages,
        certificatesUrls
      }
    });
  }}
>
  <div>
    <div className="flex w-fit">
      <button className={`xl:w-[250px] lg:w-[160px] md:w-[90px] w-[50px] h-[15px] md:h-[44px] bg-[#152C24] text-white font-bold flex items-center px-1 rounded-l-[5px]`}>
        <div className="md:text-[16px] md:px-2 text-[4px] font-cold md:mt-0 mt-[2px] bg-transparent outline-none placeholder-white">SHARE REGISTRATION</div>
      </button>
      <div className="w-[15px] h-[15px] md:h-[44px] md:w-[50px] bg-[#FDBB26] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer">
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747251939/Expand_right_wbmjno.png"
          alt="expand"
          className="w-2 h-[10px] md:w-6 md:h-[24px]"
        />
      </div>
    </div>
    <p className="md:text-[14px] text-[4px] font-normal mt-1 text-black">
      Save registration 
    </p>
  </div>
</a>
                                </div>
                            </div>
{/* Error display */}
{registrationError && (
  <div className="text-red-500 text-center mt-2">
    {registrationError}
  </div>
)}
                    <Modal
                        isOpen={isModalOpen}
                        onRequestClose={() => setIsModalOpen(false)}
                        contentLabel="Registration Successful"
                        className="modal-content"
                        overlayClassName="modal-overlay"
                        style={{
                            overlay: {
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                zIndex: 1000,
                            },
                            content: {
                                position: "relative",
                                inset: "auto",
                                width: "80%",
                                maxWidth: "800px",
                                margin: "0 auto",
                            },
                        }}>
                        <button
                            onClick={() => setIsModalOpen(false)}
                            className="absolute top-1 right-4 text-black opacity-30 hover:text-black text-[30px] font-light z-50"
                            aria-label="Close">
                            &times;
                        </button>
                        <div>
                            <div className="relative bg-white p-4 md:pt-5 rounded-lg w-[350px] md:w-[800px] mx-auto md:h-[450px]">
                                <div className="flex flex-col items-center justify-center text-center h-full w-full">
                                    <div className="relative mb-4 w-full flex justify-center items-center">
                                        <img
                                            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746440276/image_72_ifcxcp.png"
                                            alt="Success"
                                            className="absolute left-2 top-1/2 transform -translate-y-1/2 w-[24px] h-[24px] md:w-[60px] md:h-[60px]"
                                        />
                                        <div className="text-[16px] md:text-[48px] font-bold text-center w-full">
                                            {isLoggedIn
                                                ? "Update Successful"
                                                : "Registration Successful"}
                                        </div>
                                    </div>
                                    <p className="text-black text-[10px] md:text-[32px] mb-2">
                                        {isLoggedIn
                                            ? "Your details have been updated successfully!"
                                            : `Thank you for registering with Farmnet`}
                                    </p>
                                    {!isLoggedIn && (
                                        <p className="text-black text-[10px] md:text-[32px] mb-4">
                                            Your unique registration number is:
                                        </p>
                                    )}
                                    {!isLoggedIn && (
                               <div>
                               <div className="flex-1 flex justify-center">
                                                <span className="text-[12px] md:text-[36px] font-bold text-center tracking-wide">
                                                    {registrationNumber}
                                                </span>
                                            </div>
                                      
                               </div>
                               
                                    )}
                                    <div className="flex items-center justify-between w-full mb-4  md:px-10 ">
                                        <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748558039/image_1738_biv82f.png"  alt=".." className="md:w-[70px] w-[20px] h-[20px] md:h-[70px]"/>
                                       
                                            <button
                                                onClick={() => {
                                                    navigator.clipboard.writeText(
                                                        registrationNumber,
                                                    );
                                                    setCopyMessage("Copied!");
                                                    setTimeout(
                                                        () => setCopyMessage(""),
                                                        2000,
                                                    );
                                                }}
                                                className="bg-[#EEB527] hover:bg-orange-600 text-white font-light text-[10px] md:text-[32px] md:w-[140px] md:h-[60px] px-4 py-2 rounded-[10px]">
                                                Copy
                                            </button>
                                        </div>
                                    {copyMessage && (
                                        <div className="text-black text-[14px] md:text-[18px] font-semibold">
                                            {copyMessage}
                                        </div>
                                    )}
                                    <a href="/">
                                        <button
                                            onClick={() => setIsModalOpen(false)}
                                            className="bg-[#152C24] md:mt-3 hover:bg-[#1b4a46] text-[12px] md:text-[32px] text-white w-full md:w-[700px] h-[40px] md:h-[56px] px-5 py-1 rounded-md font-bold">
                                            Continue to Home
                                        </button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </Modal>
                    {/* App Download Section */}
                    <div className="md:h-4"></div>
                    <h1 className="md:text-[36px] text-[10px] font-bold md:mt-8 mt-1 mb-4">
                        Download App
                    </h1>
                    <div className="flex  justify-between gap-8 md:gap-0  items-center">
            <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744414874/image_903_oqescj.png" className="h-[25px] md:h-[76px]" alt="App Store" />
            <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744414874/image_scynki.png" className="h-[25px] md:h-[76px]" alt="Google Play" />
            <div>
  <button
    className="flex items-center justify-between w-[60px] md:w-[230px] h-[20px] md:h-[46px] bg-[#2E453D] text-white md:text-[14px] text-[6px] font-bold rounded-[5px] px-1 md:px-4"
    onClick={() => setIsAdminModalOpen(true)}
  >
    <span>ADMIN</span>
    <img
      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747168118/User_cicrle_duotone_kaenga.png"
      alt="Edit Icon"
      className="md:w-[35px] h-[6px] md:h-[38px] w-[6px]"
    />
  </button>
  <p className="md:text-[14px] text-[6px] mt-1 font-normal md:px-1">
    For official use only
  </p>
</div>


<Modal
  isOpen={isAdminModalOpen}
  onRequestClose={() => setIsAdminModalOpen(false)}
  contentLabel="Admin Login"
  className="modal-content bg-[#E7EBEB] w-[350px] md:w-[600px]"
  overlayClassName="modal-overlay"
>
  <button
    onClick={() => setIsAdminModalOpen(false)}
    className="absolute top-2 right-2 md:top-4 md:right-4 text-black opacity-50 hover:opacity-100 text-[12px] md:text-[30px] font-bold z-50"
    aria-label="Close"
  >
    &times;
  </button>
  <div className="flex justify-end"> 
    <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748281140/image_aorywu.png" alt="hi" className="md:w-[120px] md:mt-10 md:h-[22px]"/>
  </div>
  <div className="md:p-4 p-2 md:py-20">
    <h2 className="md:text-[40px] font-extrabold mb-4">
    Farm IT , Digitalize IT!

    </h2>
    <div>
    <input
  type="email"
  value={adminEmail}
  placeholder="Enter Email Address"
  onChange={(e) => {
    setAdminEmail(e.target.value);
    setAdminError(""); // Clear error when typing
  }}
  className="w-full text-[10px] shadow-inner shadow-black/40 md:text-[20px] bg-[#152C24] focus:bg-[152C24] text-white placeholder:text-white placeholder:font-bold rounded-md placeholder:pl-1 mb-4 p-2 h-[48px] md:h-[66px] md:px-6"
/>

    </div>
    <div className="relative mt-2">
    <input
      type={showPassword ? "text" : "password"}
  value={adminPassword}
  placeholder="Enter  Password"
  onChange={(e) => {
    setAdminPassword(e.target.value);
    setAdminError(""); // Clear error when typing
  }}
  className="w-full text-[10px] inner-shadow shadow-black md:text-[20px] bg-[#152C24] focus:bg-[#152C24] text-white placeholder:text-white placeholder:font-bold rounded-md placeholder:pl-1 mb-4 p-2 h-[48px] md:h-[66px] md:px-6"
/>
   <button
      type="button"
      onClick={togglePasswordVisibility}
      className="absolute right-3 md:text-[30px] top-[44%] transform -translate-y-1/2 text-[#979797]"
    >
      {showPassword ? <FiEye /> : <FiEyeOff />}
    </button>
    </div>
    {adminError && (
      <p className="text-red-500 text-sm mt-2">
        {adminError}
      </p>
    )}
    <div className="mt-6 gap-3 md:gap-8">
     
      <button
        onClick={handleAdminLogin}
        className="bg-[#FDBB26] shadow-inner shadow-black/40 font-bold md:text-[20px] text-[8px] text-white w-full px-4 md:py-4 rounded-md"
      >
    Continue
      </button>
      <p 
  className="md:text-[14px] text-[8px] md:mt-4 mt-2 font-normal cursor-pointer underline"
  onClick={() => {
    setIsForgotPasswordModalOpen(true);
    setForgotPasswordStep(1);
    setForgotPasswordError("");
    setForgotPasswordSuccess("");
  }}
>
  Forgot your password
</p>
    </div>
  </div>
</Modal>
          </div>
                    <div className="md:h-4"></div>
                </div>
            </div>
            {/* Forgot Password Modal */}
<Modal
  isOpen={isForgotPasswordModalOpen}
  onRequestClose={() => setIsForgotPasswordModalOpen(false)}
  contentLabel="Forgot Password"
  className="modal-content bg-[#E7EBEB] w-[350px] md:w-[600px]"
  overlayClassName="modal-overlay"
>
  <button
    onClick={() => {
      setIsForgotPasswordModalOpen(false);
      setForgotPasswordStep(1);
      setForgotPasswordError("");
      setForgotPasswordSuccess("");
    }}
    className="absolute top-2 right-2 md:top-4 md:right-4 text-black opacity-50 hover:opacity-100 text-[12px] md:text-[30px] font-bold z-50"
    aria-label="Close"
  >
    &times;
  </button>
  
  <div className="flex justify-end"> 
    <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748281140/image_aorywu.png" alt="hi" className="md:w-[120px] md:mt-10 md:h-[22px]"/>
  </div>
  
  <div className="md:p-4 p-2 md:py-20">
    <h2 className="md:text-[40px] font-extrabold mb-4">
      {forgotPasswordStep === 1 ? "Reset Password" : 
       forgotPasswordStep === 2 ? "Enter Verification Code" : 
       "Set New Password"}
    </h2>
    
    {forgotPasswordError && (
      <p className="text-red-500 text-sm mt-2 mb-4">
        {forgotPasswordError}
      </p>
    )}
    
    {forgotPasswordSuccess && (
      <p className="text-green-500 text-sm mt-2 mb-4">
        {forgotPasswordSuccess}
      </p>
    )}
    
    {forgotPasswordStep === 1 && (
      <>
        <p className="md:text-[16px] text-[10px] mb-4">
          Enter your registered email address to receive a verification code
        </p>
        <input
          type="email"
          value={forgotPasswordEmail}
          placeholder="Enter Email Address"
          onChange={(e) => setForgotPasswordEmail(e.target.value)}
          className="w-full text-[10px] shadow-inner shadow-black/40 md:text-[20px] bg-[#152C24] focus:bg-[152C24] text-white placeholder:text-white placeholder:font-bold rounded-md placeholder:pl-1 mb-4 p-2 h-[48px] md:h-[66px] md:px-6"
        />
        <button
          onClick={handleForgotPassword}
          className="bg-[#FDBB26] shadow-inner shadow-black/40 font-bold md:text-[20px] text-[8px] text-white w-full px-4 md:py-4 rounded-md"
        >
          Send Verification Code
        </button>
      </>
    )}
    {forgotPasswordStep === 2 && (
  <>
    <p className="md:text-[16px] text-[10px] mb-4">
      {forgotPasswordSuccess || 
       "Check your email for a password reset link. If you don't see it, check your spam folder."}
    </p>
    <button
      onClick={() => setIsForgotPasswordModalOpen(false)}
      className="bg-[#FDBB26] shadow-inner shadow-black/40 font-bold md:text-[20px] text-[8px] text-white w-full px-4 md:py-4 rounded-md"
    >
      Return to Login
    </button>
  </>
)}
    
    {forgotPasswordStep === 3 && (
      <>
        <p className="md:text-[16px] text-[10px] mb-4">
          Enter your new password
        </p>
        <input
          type="password"
          value={newPassword}
          placeholder="New Password"
          onChange={(e) => setNewPassword(e.target.value)}
          className="w-full text-[10px] shadow-inner shadow-black/40 md:text-[20px] bg-[#152C24] focus:bg-[152C24] text-white placeholder:text-white placeholder:font-bold rounded-md placeholder:pl-1 mb-4 p-2 h-[48px] md:h-[66px] md:px-6"
        />
        <input
          type="password"
          value={confirmPassword}
          placeholder="Confirm New Password"
          onChange={(e) => setConfirmPassword(e.target.value)}
          className="w-full text-[10px] shadow-inner shadow-black/40 md:text-[20px] bg-[#152C24] focus:bg-[152C24] text-white placeholder:text-white placeholder:font-bold rounded-md placeholder:pl-1 mb-4 p-2 h-[48px] md:h-[66px] md:px-6"
        />
        <button
          onClick={handleResetPassword}
          className="bg-[#FDBB26] shadow-inner shadow-black/40 font-bold md:text-[20px] text-[8px] text-white w-full px-4 md:py-4 rounded-md"
        >
          Reset Password
        </button>
      </>
    )}
  </div>
</Modal>
            {isPDFReady && (
  <PDFGenerator 
    ref={pdfGeneratorRef}
    registrationData={{
      personalInfo: formData,
      organizationInfo: orgFormData,
      dropdownSelections,
      reportSelections,
      selectedLanguage,
      landData,
      selectedSkills,
      membershipData,
      selectedExperience,
      focusSelected,
      sectionD: {
        selectedType,
        selectedOption,
        selectedCategories
      },
      industry: { 
        selectedChallenges: (selectedChallenges || []).map(challenge => ({
          id: challenge.id || "",
          title: challenge.title || "",
          description: challenge.description || "",
          solution: challenge.solution || "",
          code: challenge.code || "" // Make sure to include the code
        })),
        vision: vision || ""
      },
      setaQualification: {
        selectedS,
        selectedQ
      },
      location: userLocation,
      registrationNumber,
      idDocumentUrl,
      profileImage,
      productImages,
      certificatesUrls
    }}
  />
)}

        </div>

        
    );
};

export default RegisterAsFarm;